import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import * as actionUrl from "../../store/actions";
import { useSelector } from "react-redux";
import TableComponent from "./Table";
import EnglishTable from "./EnglishTable";
import { useTimer } from "react-timer-hook";
import "../../assets/css/englishAuction.css";
import CustomToast from "../../components/Toast";
import { ThreeDots } from "react-loader-spinner";
import { Button, Modal, ModalBody, Form } from "react-bootstrap";
import { DataTypeProvider } from "@devexpress/dx-react-grid";
import SockJS from "sockjs-client";
import Stomp from "stompjs";
import { Table } from "react-bootstrap";
import YourComponent from "./headerOfAuction";
import SessionRemaining from "./sessionRemainingTime";
import NotificationMsg from "./notification";
import { toast } from "react-toastify";
import { ModelTraining } from "@mui/icons-material";
import MBTTime from "./mbtTime";
import CatalogTable from "./CatalogTable";
import { isRpButtonClickedTrue } from "../../store/actions";
let sahilcheck = false;
let activeTab = 0;
let socket = true;
let itemIDAuc = 0;
let AuctioneerCodeSocket = 0;
let commonUserIdSocket = 0;

//let stompClient = null;
const auctionDetailId =
  window.location.pathname &&
  window.location.pathname.split("/") &&
  window.location.pathname.split("/")[2]
    ? atob(
        window.location.pathname &&
          window.location.pathname.split("/") &&
          window.location.pathname.split("/")[2]
      )
    : "";
//866;
//817
const userId =
  window.location.pathname &&
  window.location.pathname.split("/") &&
  window.location.pathname.split("/")[3]
    ? atob(
        window.location.pathname &&
          window.location.pathname.split("/") &&
          window.location.pathname.split("/")[3]
      )
    : "";
//10929;
const auctionCenterIdFromURI =
  window.location.pathname &&
  window.location.pathname.split("/") &&
  window.location.pathname.split("/")[4]
    ? atob(
        window.location.pathname &&
          window.location.pathname.split("/") &&
          window.location.pathname.split("/")[4]
      )
    : "";
const astatus = "Active";
const userRoleCode = atob(localStorage.getItem("argument6"));
const AIR = userRoleCode == "AUCTIONEER" ||
userRoleCode == "ASSOCIATEAUCTIONEER" ||
userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER" ? true : false;
const EnglishAuction = () => {
  const dispatch = useDispatch();
  const [rows, setRows] = useState([]);
  const [leftColumns, setLeftColumns] = useState([]);
  const [truefalse, settruefalse] = useState(true);

  const [rightColumns, setRightColumns] = useState([]);
  const [userWiseViewEnglishAuctionData, setuserWiseViewEnglishAuctionData] =
    useState([]);
  const [groupCode11, setgroupCode11] = useState("");
  const [fixedColumns, setFixedColumns] = useState([]);
  const [ChangePriceModel, setChangePriceModel] = useState(false);
  const [showListMsg, setshowListMsg] = useState(false);
  const [showMarketDepth, setshowMarketDepth] = useState(false);
  const [loader, setLoader] = useState(false);
  const [selectedAuctioneer, setSelectedAuctioneer] = useState(null);
  const [commonUserId, setcommonUserId] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedRowsRemove, setSelectedRowsRemove] = useState([]);
  const [SelectedAuctionItem, setSelectedAuctionItem] = useState(null);
  const [showMainTable, setShowMainTable] = useState(true);
  const [showTable, setShowTable] = useState(true);
  const [selectedRadio, setSelectedRadio] = useState("RsChangeRP");
  const [lotNo, setLotNo] = useState("");
  const [textBoxValue, setTextBoxValue] = useState("");
  const [lotNos, setLotNos] = useState([]);
  const [Mark, setMark] = useState([]);
  const [GroupCode, setGroupCode] = useState([]);
  const [Comments, setComments] = useState([]);
  const [Valuation, setValuation] = useState([]);
  const [grade, setGrade] = useState([]);
  const [NewRP, setNewRP] = useState([]);
  const [NewRPHBP, setNewRPHBP] = useState([]);
  const [auctionItemDetails, setAuctionItemDetails] = useState([]); 
  const [exportType, setexportType] = useState("");
  const [itemIdExport, setitemIdExport] = useState(null);
  let selectedDataForMyCatalog = [];
  const auctionitemId = Array.isArray(selectedRowsRemove)
    ? selectedRowsRemove[0]
    : selectedRowsRemove;
  const [formData, setFormData] = useState({
    commonUserId: userId,
    auctionDetailId: auctionDetailId,
    auctionItemDetailId: auctionitemId,
    myComments: "",
    groupCode: GroupCode || "",
    myValuation: "",
  });
  const [validationErrors, setValidationErrors] = useState({
    valuation: "",
    comments: "",
  });
  let isTimeAvailable = false;
  const [auctionItemId, setauctionItemId] = useState(0);
  const [
    allFetchAuctionCenterDataApiCallResponse,
    setAllFetchAuctionCenterDataApiCallResponse,
  ] = useState(false);
  const handleLotClick = (auctionItemDetailId) => {
    setSelectedAuctionItem(auctionItemDetailId);
    setShowMainTable(false);
    dispatch(
      actionUrl.getViewTeaSoldByLotIdAction({
        auctionDetailId: auctionDetailId,
        auctionItemDetailId: auctionItemDetailId,
      })
    );
  };
  const moduleList = useSelector(
    (state) => state?.ModuleReducer?.data?.responseData
  );

  const [rightsIdData, setRightsIdData] = useState([]);
  const [auctionItemRowId, setAuctionItemRowId] = useState(null);

  if (
    moduleList !== null &&
    moduleList !== undefined &&
    rightsIdData?.length == 0
  ) {
    setRightsIdData(
      moduleList?.auctionCentersList
        ?.map((auctionCenters) => auctionCenters.modulesDtoList)
        ?.at(0)
        ?.filter((modulesDto) => modulesDto.moduleid == 3)
        ?.at(0)
        ?.linksDtoList?.filter((linksDto) => linksDto.linkId == 52)
        ?.at(0)?.rightIds
    );
  }
  useEffect(() => {
    if (true == fetchAuctionCenterDataApiCallResponse) {
      setfetchAuctionCenterDataApiCallResponse(false);
    }
  });
  const [
    fetchAuctionCenterDataApiCallResponse,
    setfetchAuctionCenterDataApiCallResponse,
  ] = useState(false);

  useEffect(() => {
    if (true == allFetchAuctionCenterDataApiCallResponse) {
      setAllFetchAuctionCenterDataApiCallResponse(false);
    }
  });
  const handleBackClick = () => {
    setShowMainTable(true);
  };

  const handleDragStart = (e, index) => {
    e.dataTransfer.setData("index", index);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const GroupCodedata = useSelector(
    (state) => state?.EnglishVR?.groupCodedata?.responseData
  );

  const handleDrop = (e, dropIndex) => {
    e.preventDefault();
    const dragIndex = parseInt(e.dataTransfer.getData("index"));

    if (!isNaN(dragIndex)) {
      // Create a copy of the columns to perform the drag & drop
      const newColumns = [...myCatalogViewdata.columnDetails];

      // Get the dragged column
      const draggedColumn = newColumns[dragIndex];

      // Remove dragged column and place it at the dropIndex
      newColumns.splice(dragIndex, 1);
      newColumns.splice(dropIndex, 0, draggedColumn);

      // Update sortOrder
      const updatedColumns = [...newColumns];

      // Adjust the sortOrder for the affected columns
      const dragSortOrder = updatedColumns[dragIndex].sortOrder;

      if (dragIndex < dropIndex) {
        updatedColumns.forEach((column, index) => {
          if (index === dropIndex) {
            column.sortOrder = index + 1;
          } else if (index === dragIndex) {
            column.sortOrder = index + 1;
          } else if (index > dragIndex && index <= dropIndex) {
            column.sortOrder = index + 1;
          }
        });
      } else {
        // If dragging the item after the target (dragIndex > dropIndex), we shift sort orders up
        updatedColumns.forEach((column, index) => {
          if (index === dropIndex) {
            column.sortOrder = index + 1;
          } else if (index === dragIndex) {
            column.sortOrder = index + 1;
          } else if (index < dragIndex && index >= dropIndex) {
            column.sortOrder = index + 1;
          }
        });
      }

      // Now, update the auctionDataLiveBidDetails to reflect the column order change
      // myCatalogViewdata &&
      // myCatalogViewdata.columnDetails.map((row) => {
      let dragData = myCatalogViewdata.columnDetails[dragIndex];
      myCatalogViewdata.columnDetails.splice(dragIndex, 1);
      myCatalogViewdata.columnDetails.splice(dropIndex, 0, dragData);
      // });

      // If needed, you can dispatch your updated columns here:

      setTimeout(() => {
        const payloadData = {
          auctionDetailId: auctionDetailId,
          userLoginId: userId,
          catalogColumnConfigurationDetails: updatedColumns, // Use the updated columns with correct sortOrder
        };

        // Dispatch the API request to update the catalog column config
        dispatch(actionUrl.CatalogColumnConfigAction(payloadData));
      }, 1000);
    }
  };

  const handleSelectRow = (auctionItemDetailId) => {
    if (selectedRows.includes(auctionItemDetailId)) {
      setSelectedRows(selectedRows.filter((id) => id !== auctionItemDetailId));
    } else {
      setSelectedRows([...selectedRows, auctionItemDetailId]);
    }
  };
  const handleChangePriceButton = () => {
    if (selectedRowsRemove.length === 0) {
      toast.error("Please select at least one Lot No.");
      return;
    }
    setChangePriceModel(true);
  };

  useEffect(() => {
    if (GroupCode) {
      setgroupCode11(GroupCode);
      setFormData((prevData) => ({
        ...prevData,
        groupCode: GroupCode,
      }));
    }

    if (Comments) {
      // setComments11(Comments);
      setFormData((prevData) => ({
        ...prevData,
        myComments: Comments,
      }));
    }

    if (Valuation) {
      // setvaluation11(Valuation);
      setFormData((prevData) => ({
        ...prevData,
        myValuation: Valuation,
      }));
    }
  }, [GroupCode, Comments, Valuation]);

  useEffect(() => {
    if(GroupCodedata && GroupCodedata?.[0]?.length === 1) {
      setGroupCode(GroupCodedata[0]?.[0])
    }
  }, [GroupCodedata])
  const resetForm = () => {
    setsearchlotNo("");
    setSearchGradeCode("");
    setmarkCode("");
    setsearchlotStatus("");
    let payloadData = {
      auctionDetailId: auctionDetailId,
      commonUserId: userId,
      lotNo: null,
      markId: null,
      gradeId: null,
      lotStatus: null,
      sessionTime: null,
      auctionItemDetailId: null,
      isLiveBidBook: 1,
      auctionCenterId: auctionCenterIdFromURI,
      isfirstcall: true,
    };
    dispatch(actionUrl.fetchBidBookRequest(payloadData));
  };
  const handleSubmitValue = (event) => {
    event.preventDefault();
    const payload = {
      commonUserId: formData.commonUserId,
      auctionDetailId: formData.auctionDetailId,
      auctionItemDetailId: auctionitemId,
      groupCode:
        Array.isArray(groupCode11) && groupCode11.length === 0
          ? ""
          : groupCode11,
      myComments:
        Array.isArray(formData.myComments) && formData.myComments.length === 0
          ? ""
          : formData.myComments,
      myValuation:
        Array.isArray(formData.myValuation) && formData.myValuation.length === 0
          ? ""
          : formData.myValuation,
    };
    setLoader(true);
    dispatch(actionUrl.addvaluationAction(payload));
  };
  const handleValuationButton = () => {
    if (selectedRowsRemove.length === 0) {
      toast.error("Please select at least one Lot No.");
      return;
    }
    if (selectedRowsRemove.length > 1) {
      toast.error("Please select only one Lot No.");
      return;
    }
    dispatch(
      actionUrl.GetGroupCodeAction({
        auctionDetailId: auctionDetailId,
        userLoginId: userId,
      })
    );
    setshowValuation(true);
  };

  const handleSelectRowRemove = (auctionItemDetailId, column) => {
    // Temporary arrays to hold selected values for various properties
    let selectedColumnValues = [...lotNos];
    let selectedMark = [...Mark];
    let selectGrade = [...grade];
    let selectedGroupCode = Array.isArray(GroupCode) ? [...GroupCode] : [];
    let selectedValuation = Array.isArray(Valuation) ? [...Valuation] : [];
    let selectedComments = Array.isArray(Comments) ? [...Comments] : [];
    let Rpvalue = "";
    let value = "";
    let HBP = "";
    let rrp = "";
  
    column.forEach((row) => {
      if (row.columnTypeId === 11) {
        HBP = row.columnValue;
      }
      if (row.columnTypeId === 48) {
        Rpvalue = row.columnValue;  // Store the Rpvalue
      } else if (row.columnTypeId === 1) {
        value = row.columnValue;
      }
      if(row.columnTypeId == 13) {
        rrp = row.columnValue;  
      }
    });

    const handleToggle = (array, detail, typeId) => {
      if (detail.columnTypeId === typeId) {
        const index = array.indexOf(detail.columnValue);
        if (index !== -1) {
          array.splice(index, 1);
        } else {
          array.push(detail.columnValue);
        }
      }
    };
  
    // Handle if the auctionItemDetailId is already selected
    setSelectedRowsRemove((prevSelectedRows) => {
      let newSelectedRows = new Set(prevSelectedRows);
      let isCurrentlySelected = newSelectedRows.has(auctionItemDetailId);
  
      // If currently selected, deselect
      if (isCurrentlySelected) {
        newSelectedRows.delete(auctionItemDetailId);
  
        // Deselect row and remove associated values
        column.forEach((detail) => {
          handleToggle(selectedColumnValues, detail, 1);
          handleToggle(selectedMark, detail, 7);
          handleToggle(selectGrade, detail, 6);
          handleToggle(selectedGroupCode, detail, 43);
          handleToggle(selectedValuation, detail, 42);
          handleToggle(selectedComments, detail, 41);
        });
  
        // Remove the Rpvalue from state
        setAuctionItemDetails((prevDetails) => {
          const updatedDetails = { ...prevDetails };
          if (updatedDetails[auctionItemDetailId]) {
            // Remove the Rpvalue (if it exists)
            delete updatedDetails[auctionItemDetailId];
          }
          return updatedDetails;
        });
      } else {
        // If not selected, add it to the selected rows
        newSelectedRows.add(auctionItemDetailId);
  
        // Add values to the arrays
        column.forEach((detail) => {
          if (detail.columnTypeId === 1) {
            selectedColumnValues.push(detail.columnValue);
          } else if (detail.columnTypeId === 7) {
            selectedMark.push(detail.columnValue);
          } else if (detail.columnTypeId === 6) {
            selectGrade.push(detail.columnValue);
          } else if (detail.columnTypeId === 43) {
            selectedGroupCode.push(detail.columnValue);
          } else if (detail.columnTypeId === 42) {
            selectedValuation.push(detail.columnValue);
          } else if (detail.columnTypeId === 41) {
            selectedComments.push(detail.columnValue);
          }
        });
  
        // Add the Rpvalue as an object, with auctionItemDetailId as the key
        setAuctionItemDetails((prevDetails) => {
          const updatedDetails = { ...prevDetails };
          if (!updatedDetails[auctionItemDetailId]) {
            updatedDetails[auctionItemDetailId] = [];  // Initialize with an empty array
          }
          // Overwrite the Rpvalue (store as an array with a single element)
          updatedDetails[auctionItemDetailId] = [Rpvalue];
  
          return updatedDetails;
        });
      }
  
      // Update selected rows with the new Set
      return Array.from(newSelectedRows);
    });
  
    // Update other states
    setLotNo(value);

    setNewRPHBP((prevRP) => {
      let updatedRP = { ...prevRP };
      if (updatedRP[auctionItemDetailId]) {
        if (!updatedRP[auctionItemDetailId].includes(HBP)) {
          updatedRP[auctionItemDetailId] = [
            ...updatedRP[auctionItemDetailId],
            Rpvalue,
          ];
        }
      } else {
        updatedRP[auctionItemDetailId] = [HBP - rrp];
      }
      return updatedRP;
    });
    setLotNos(selectedColumnValues);
    setMark(selectedMark);
    setGrade(selectGrade);
    setGroupCode(
      selectedGroupCode[0] !== undefined && selectedGroupCode[0] !== ""
        ? selectedGroupCode[0]
        : ""
    );
    setValuation(
      selectedValuation[0] !== undefined && selectedValuation[0] !== ""
        ? selectedValuation[0]
        : ""
    );
    setComments(
      selectedComments[0] !== undefined && selectedComments[0] !== ""
        ? selectedComments[0]
        : ""
    );
  };

  const handleBackeClick = () => {
    setShowTable(true);
  };

  const handleRadioChange = (event) => {
    setSelectedRadio(event.target.value);
  };

  const handleCloseChangePrice = () => {
    setChangePriceModel(false);
    setTextBoxValue("");
    setSelectedRowsRemove([]);
    setLotNos([]);
  };
  const handleCloseMsg = () => {
    setshowListMsg(false);
    setChangePriceModel(false);
  };

  const handleCloseMarketDepth = () => {
    setshowMarketDepth(false);
  };

  const handleTextBoxChange = (event) => {
    setTextBoxValue(event.target.value);
  };
  const handleClosemyplanner = () => setmyplanner(false);
  const handleClosemyCatalog = () => {
    setSelectedRowsRemove([]);
    setmyCatalog(false);
  };

  const handleAuctioneerClick = (commonUserId, auctioneerCode) => {
    setcommonUserId(commonUserId);
    setSelectedAuctioneer(auctioneerCode);
    AuctioneerCodeSocket = auctioneerCode;
    commonUserIdSocket = commonUserId;
    setShowTable(false);

    dispatch(
      actionUrl.getViewTeaSoldMarketIdAction({
        auctionDetailId: auctionDetailId,
        commonUserId: commonUserId,
      })
    );
  };
  const [leftNo, setLeftNo] = useState(0);
  const [leftNoCatalog, setLeftNoCatalog] = useState(0);
  const [showSideSlide, setShowSideSlide] = useState(false);
  const [showmyplanner, setmyplanner] = useState(false);
  const [showmyCatalog, setmyCatalog] = useState(false);
  const [showmyAuctioneer, setmyAuctioneer] = useState(false);
  const handleShowSideSlide = () => {
    activeTab = 3;
    setShowSideSlide(true);
    // setmyplanner(false);
    // setmyCatalog(false);
    // setshowMarketDepth(false);
    dispatch(actionUrl.getViewTeaSoldIdAction(auctionDetailId));

    dispatch(actionUrl.getauctioneerIdAction(auctionDetailId));
    dispatch(actionUrl.getviewmarketsummaryIdAction(auctionDetailId));
  };
  const handleMyCatalog = () => {
    setmyCatalog(true);
    setmyAuctioneer(false);
    activeTab = 1;
    sahilcheck = true;
    // setmyplanner(false);
    // setShowSideSlide(false);
    // setshowMarketDepth(false);
    dispatch(
      actionUrl.MyCatalogViewIdAction({
        auctionDetailId: auctionDetailId,
        userLoginId: userId,
      })
    );
  };

  const handleMyAuctioneer = (flag) => {
    activeTab = 0;
    sahilcheck = false;
    setmyAuctioneer(flag);
    setmyCatalog(false);
  };

  const handleMyPlanner = () => {
    activeTab = 2;
    setmyplanner(true);
    // setShowSideSlide(false);
    // setmyCatalog(false);
    // setshowMarketDepth(false);
    dispatch(
      actionUrl.getMyplannerIdAction({
        auctionDetailId: auctionDetailId,
        commonUserId: userId,
      })
    );
  };
  const bidBookANDMyPlannerExportData = useSelector(
    (state) => state?.englishAuctionReducer?.bidBookExport?.responseData
  );
  const handleCloseSideSlide = () => {
    setShowSideSlide(false);
    handleBackClick();
    handleBackeClick();
  };
  const handleExport = (exportType) => {
    setexportType("");
    let payloadData = {
      auctionDetailId: auctionDetailId,
      commonUserId: userId,
      lotNo: searchlotNo,
      lotStatus: searchlotStatus,
      markId: markCode,
      gradeId: searchGradeCode,
      auctionItemDetailId: itemIdExport,
      isLiveBidBook: 1,
      isfirstcall: false,
      auctionCenterId: auctionCenterIdFromURI,
      isExport: 1,
      exportType: exportType,
    };
    dispatch(actionUrl.fetchBidBookRequest(payloadData));
    setexportType(exportType);
  };
  const handleMyplannerExport = (exportType) => {
    dispatch(
      actionUrl.getMyplannerIdAction({
        auctionDetailId: auctionDetailId,
        commonUserId: userId,
        exportType: exportType,
        isExport: 1,
      })
    );
  };

  const downloadFile = (base64String, fileName, contentType) => {
    // Convert the base64 string to a Blob
    const byteCharacters = atob(base64String);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });

    // Create a link element, hide it, direct download
    const a = document.createElement("a");
    a.style.display = "none";
    document.body.appendChild(a);

    // Create a DOMString representing the blob and point the link element towards it
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = fileName;

    // Trigger the download
    a.click();

    // Cleanup
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  };
  useEffect(() => {
    if (
      bidBookANDMyPlannerExportData != null &&
      bidBookANDMyPlannerExportData != undefined &&
      bidBookANDMyPlannerExportData != []
    ) {
      if (bidBookANDMyPlannerExportData.sahilfrom == "myplanner") {
        let contentType =
          bidBookANDMyPlannerExportData.exportType == "pdf"
            ? "application/pdf"
            : bidBookANDMyPlannerExportData.exportType == "excel"
            ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            : "";
        downloadFile(
          bidBookANDMyPlannerExportData?.exported_file,
          "My planner",
          contentType
        );
      } else {
        let contentType =
          exportType == "pdf"
            ? "application/pdf"
            : exportType == "excel"
            ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            : "";
        downloadFile(
          bidBookANDMyPlannerExportData?.exported_file,
          "View Bid Book",
          contentType
        );
      }
    }
  }, [bidBookANDMyPlannerExportData]);
  const [rightNo, setRightNo] = useState(0);
  const [rightNoCatalog, setRightNoCatalog] = useState(0);
  const [show, setShow] = useState(false);
  const [bidbookshow, setbidbookShow] = useState(false);
  const [showColumn, setshowColumn] = useState(false);
  const [showValuation, setshowValuation] = useState(false);
  const handleCloseValuation = () => {
    setFormData({
      commonUserId: userId,
      auctionDetailId: auctionDetailId,
      auctionItemDetailId: auctionitemId,
      myComments: "",
      myValuation: "",
    });
    setshowValuation(false);
    setSelectedRowsRemove([]);
    setGroupCode([]);
    setMark([]);
    setLotNos([]);
    setGrade([]);
    setComments([]);
    setValuation([]);
  };
  const time = new Date();
  const sessiontime = new Date();
  const lotRemainingTime = new Date();
  const [stickyInput, setStickyInput] = useState({
    leftNo: 0,
    rightNo: 0,
  });
  const [tableColumnExtensions] = useState([
    { columnName: "LotNo", width: 125 },
    { columnName: "Session Period" },
    { columnName: "Session Status" },
    { columnName: "Session Type" },
  ]);
  const StatusList = ({ value }) => (
    <span className="badge badge-secondary w-100">{value}</span>
  );
  const [leftDbData, setLeftDbData] = useState([]);
  const [rightDbData, setRightDbData] = useState([]);
  const [leftData, setLeftData] = useState([]);
  const [rightData, setRightData] = useState([]);
  let remainingSeconds = 0;
  const defaultConfigColumnDetails = useSelector(
    (state) => state?.englishAuctionReducer?.defaultColumnConfig?.responseData
  );
  const bidBookData = useSelector(
    (state) => state?.englishAuctionReducer?.bidBook?.responseData
  );

  const bidBookDropdownData = useSelector(
    (state) =>
      state?.englishAuctionReducer?.searchBidBookdropdownData?.responseData
  );
  const [searchlotStatus, setsearchlotStatus] = useState("");
  const lotNumbers =
    bidBookData != undefined ? bidBookData.map((item) => item?.lotNo) : [];
  const gradedropdown =
    bidBookData != undefined ? bidBookData.map((item) => item?.grade) : [];
  const markdropdown =
    bidBookData != undefined ? bidBookData.map((item) => item?.mark) : [];
  const uniqueData = [];
  const uniqueCombinationSet = new Set();
  const [gradeDropdownData, setGradeDropdownData] = useState([]);
  const [markDropdownData, setMarkDropdownData] = useState([]);
  const [lotDropdownData, setLotDropdownData] = useState([]);

  useEffect(() => {
    if (bidBookDropdownData != undefined && bidBookDropdownData != []) {
      const gradeSet = new Map();
      const markMap = new Map(); // Using Map to store markId-mark pairs
      const lotSet = new Set();
      bidBookDropdownData.forEach((item) => {
        gradeSet.set(item.gradeId, item.grade);
        markMap.set(item.markId, item.mark);
        lotSet.add(item.lotNo);
      });
      const uniqueGrades = Array.from(gradeSet).map(([gradeId, grade]) => ({
        gradeId,
        grade,
      }));
      const uniqueMarks = Array.from(markMap).map(([markId, mark]) => ({
        markId,
        mark,
      }));
      const uniqueLots = Array.from(lotSet).map((lotNo) => ({ lotNo }));
      setGradeDropdownData(uniqueGrades);
      setMarkDropdownData(uniqueMarks);
      setLotDropdownData(uniqueLots);
    }
  }, [bidBookDropdownData]);

  const [searchlotNo, setsearchlotNo] = useState("");
  const [markCode, setmarkCode] = useState("");
  const [searchGradeCode, setSearchGradeCode] = useState("");
  const loaderBidBook = useSelector(
    (state) => state?.englishAuctionReducer?.loading
  );
  const [localConfigColumnDetails, setLocalConfigColumnDetails] = useState([]);

  const [CatalogConfigColumnDetails, setCatalogConfigColumnDetails] = useState(
    []
  );
  const userWiseConfigData = useSelector(
    (state) => state?.EnglishVR?.userWisecolumnConfig?.responseData
  );
  useEffect(() => {
    setCatalogConfigColumnDetails(userWiseConfigData);
  }, [userWiseConfigData]);
  const lastIndex = fixedColumns?.map((ele) => ele);
  lastIndex?.reverse();

  const catelogAddData = useSelector(
    (state) => state?.englishAuctionReducer?.catelogAddData
  );

  const columnConfig = useSelector((state) => state?.EnglishVR?.columnConfig);

  const [editableRowId, setEditableRowId] = useState(null);
  const [rpvalue, setRpValue] = useState(null);

  const [stompClient, setStompClient] = useState(null);

  const handleDoubleClick = (auctionItemDetailId, rpvalue) => {
    setPreviousValue(rpvalue);
    if (userRoleCode == "AUCTIONEER") {
      setEditableRowId(auctionItemDetailId);
      setRpValue(rpvalue);
    }
  };

  const [previousValue, setPreviousValue] = useState(null);

  const onBlurRPTextField = (auctionItemDetailId, value) => {
    let newRp = value - previousValue;

    const payload = {
      auctionDetailId: auctionDetailId,
      auctionItemDetailIds: [
        {
          auctionItemDetailId: auctionItemDetailId,
          newRP: newRp,
        },
      ],
    };

    if (newRp != 0) {
      dispatch(actionUrl.ChangeReservePriceAction(payload));
      setshowListMsg(true);
      setRpValue(rpvalue);
    }
    setEditableRowId(null);
  };

  useEffect(() => {
    setLocalConfigColumnDetails(defaultConfigColumnDetails);
  }, [defaultConfigColumnDetails]);
  useEffect(() => {
    if (auctionDetailId != 0 && userId != 0) {
      dispatch(actionUrl.fetchEnglishAuctionHeaderDataRequest(auctionDetailId));
      dispatch(
        actionUrl.viewUserWiseLiveEnglishAuctionRequest({
          auctionDetailId: auctionDetailId,
          userLoginId: userId,
          sahilset: 1,
        })
      );
    }
  }, [catelogAddData]);

  useEffect(() => {
    if (auctionDetailId != 0 && userId != 0) {
      dispatch(
        actionUrl.MyCatalogViewIdAction({
          auctionDetailId: auctionDetailId,
          userLoginId: userId,
        })
      );
    }
  }, [columnConfig]);

  const handleStickySubmit = () => {
    setRightNo(stickyInput.rightNo);
    setLeftNo(stickyInput.leftNo);
    let finalupdatedetails = localConfigColumnDetails;
    let rightcheck = finalupdatedetails.length - stickyInput.rightNo;

    // for (let i = 0; i < finalupdatedetails.length; i++) {
    //   if (stickyInput.leftNo > i) {
    //     finalupdatedetails[i].isLocked = 1;
    //   } else if (rightcheck < i) {
    //     finalupdatedetails[i].isLocked = 1;
    //   } else {
    //     finalupdatedetails[i].isLocked = 0;
    //   }
    // }
    let payloadData = {
      auctionDetailId: auctionDetailId,
      userLoginId: userId,
      catalogColumnConfigurationDetails: finalupdatedetails,
    };
    dispatch(actionUrl.addCatalogColumnConfigRequest(payloadData));
    setShow(false);
  };

  const handleCatalogStickySubmit = () => {
    setRightNoCatalog(stickyInput.rightNoCatalog);
    setLeftNoCatalog(stickyInput.leftNoCatalog);
    let finalupdatedetails = CatalogConfigColumnDetails;
    let rightcheck = finalupdatedetails.length - stickyInput.rightNoCatalog;
    let payloadData = {
      auctionDetailId: auctionDetailId,
      userLoginId: userId,
      catalogColumnConfigurationDetails: finalupdatedetails,
    };
    setLoader(true);
    dispatch(actionUrl.CatalogColumnConfigAction(payloadData));
    setshowColumn(false);
  };

  useEffect(() => {
    if (auctionDetailId != 0 && userId != 0) {
      dispatch(actionUrl.fetchEnglishAuctionHeaderDataRequest(auctionDetailId));
      dispatch(
        actionUrl.viewUserWiseLiveEnglishAuctionRequest({
          auctionDetailId: auctionDetailId,
          userLoginId: userId,
          sahilset: 1,
        })
      );
      dispatch(
        actionUrl.viewBidRequest({
          auctionDetailId: auctionDetailId,
          userLoginId: userId,
        })
      );
    }
  }, []);
  useEffect(() => {
    if (
      rightsIdData &&
      rightsIdData?.length &&
      rightsIdData?.length > 0 &&
      rightsIdData?.includes("43")
    ) {
      handleMyAuctioneer(true);
    } else {
      handleMyAuctioneer(false);
    }
  }, [rightsIdData]);
  const selectRecord = (key, value, columnTypeId) => {
    const updatedDetails = localConfigColumnDetails.map((innerData) => {
      if (innerData.columnTypeId === columnTypeId) {
        return { ...innerData, [key]: value };
      }
      return innerData;
    });
    setLocalConfigColumnDetails(updatedDetails);
  };

  const selectRecordCatalog = (key, value, columnTypeId) => {
    const updatedDetails = CatalogConfigColumnDetails.map((innerData) => {
      if (innerData.columnTypeId === columnTypeId) {
        return { ...innerData, [key]: value };
      }
      return innerData;
    });
    setCatalogConfigColumnDetails(updatedDetails);
  };

  const alertMessage = useSelector(
    (state) => state?.EnglishVR?.changePrice?.responseData
  );

  const myCatalogView = useSelector(
    (state) => state?.EnglishVR?.Viewcatalog?.responseData
  );

  const [myCatalogViewdata, setMyCatalogViewData] = useState(myCatalogView);

  useEffect(() => {
    setMyCatalogViewData(myCatalogView);
  }, [myCatalogView]);

  const handleSubmitBidBook = (event) => {
    let payloadData = {
      auctionDetailId: auctionDetailId,
      commonUserId: userId,
      lotNo: searchlotNo,
      lotStatus: searchlotStatus,
      markId: markCode,
      gradeId: searchGradeCode,
      auctionItemDetailId: null,
      isLiveBidBook: 1,
      isfirstcall: false,
      auctionCenterId: auctionCenterIdFromURI,
    };
    dispatch(actionUrl.fetchBidBookRequest(payloadData));
  };
  const handleSubmit = () => {
    const isRsChangeRP = selectedRadio === "RsChangeRP";
    const newRPValue = isRsChangeRP ? parseFloat(textBoxValue) : auctionItemDetails;

    const auctionItemDetailIds = selectedRowsRemove.map((id) => ({
      auctionItemDetailId: id,
      newRP: isRsChangeRP ? newRPValue : auctionItemDetails[id] ? auctionItemDetails[id][0] : 0,
    }));

    const payload = {
      auctionDetailId: auctionDetailId,
      auctionItemDetailIds: auctionItemDetailIds,
      isManualCheck: isRsChangeRP ? 1 : 0
    };
    if (isRsChangeRP && isNaN(newRPValue)) {
      CustomToast.error(
        "Please enter valid Reserve Price in Lot no. in case of blank."
      );
      return;
    }
    dispatch(actionUrl.ChangeReservePriceAction(payload));
    // setshowListMsg(true);
    setTextBoxValue("");
    setChangePriceModel(false);
    setSelectedRowsRemove([]);
    setLotNos([]);
  };

  const userWiseViewEnglishAuctionDataFromAPI = useSelector(
    (state) =>
      state?.englishAuctionReducer?.userWiseViewEnglishAuctionData?.responseData
  );
  const viewBidOnlyData = useSelector(
    (state) => state?.englishAuctionReducer?.viewBidDataOnly?.responseData
  );
  useEffect(() => {
    setuserWiseViewEnglishAuctionData(userWiseViewEnglishAuctionDataFromAPI);
  }, [userWiseViewEnglishAuctionDataFromAPI]);
  useEffect(() => {
    if (userWiseViewEnglishAuctionData && viewBidOnlyData) {
      const updatedData = userWiseViewEnglishAuctionData.liveBidDetails.map(
        (row, index) => {
          // Process columnDetails
          const updatedColumnDetails = row.columnDetails?.map((item, i) => {
            switch (item.columnTypeId) {
              case 32:
                // Column Type ID 32 logic
                return { ...item, columnValue: item.columnValue }; // Return updated item immutably
              case 35:
                // Column Type ID 35 logic
                return { ...item, columnValue: item.columnValue }; // Return updated item immutably
              case 36:
                // Column Type ID 36 logic
                return { ...item, columnValue: item.columnValue }; // Return updated item immutably
              default:
                // Handle default case
                return {
                  ...item,
                  columnValue:
                    viewBidOnlyData.liveBidDetails[index]?.columnDetails[i]
                      ?.columnValue,
                  columnColor:
                    viewBidOnlyData.liveBidDetails[index]?.columnDetails[i]
                      ?.columnColor,
                }; // Return updated item immutably
            }
          });

          // Return updated row object
          return {
            ...row,
            auctionItemDetailId:
              viewBidOnlyData.liveBidDetails[index]?.auctionItemDetailId,
            categoryId: viewBidOnlyData.liveBidDetails[index]?.categoryId,
            isActive: viewBidOnlyData.liveBidDetails[index]?.isActive,
            isBQEnable: viewBidOnlyData.liveBidDetails[index]?.isBQEnable,
            isEnable: viewBidOnlyData.liveBidDetails[index]?.isEnable,
            isItemSelected:
              viewBidOnlyData.liveBidDetails[index]?.isItemSelected,
            isShowRP: viewBidOnlyData.liveBidDetails[index]?.isShowRP,
            columnDetails: updatedColumnDetails, // Update columnDetails with the updated array
          };
        }
      );

      // Update userWiseViewEnglishAuctionDataFromAPI immutably
      const updatedUserWiseViewData = {
        ...userWiseViewEnglishAuctionData,
        liveBidDetails: updatedData,
      };

      // Update state
      setuserWiseViewEnglishAuctionData(updatedUserWiseViewData);
    }
  }, [viewBidOnlyData]);

  const bidsubmitted = useSelector(
    (state) => state?.englishAuctionReducer?.lotWiseBidAcceptData?.responseData
  );
  const bidSubmittedData = useSelector(
    (state) => state?.englishAuctionReducer?.lotWiseBidAcceptData
  );

  useEffect(() => {
    if (
      bidSubmittedData?.auctionItemDetailId &&
      bidSubmittedData?.buyingQuantity
    ) {
      setuserWiseViewEnglishAuctionData((prevData) => {
        const updatedData = prevData.liveBidDetails.map((item) => {
          if (
            item.auctionItemDetailId === bidSubmittedData?.auctionItemDetailId
          ) {
            const updatedColumnDetails = item.columnDetails.map(
              (columnDetail) => {
                if (columnDetail.columnTypeId === 10) {
                  columnDetail.columnValue = bidSubmittedData?.buyingQuantity;
                }
                return columnDetail;
              }
            );

            item.columnDetails = updatedColumnDetails;
          }
          return item;
        });
        return { ...prevData, liveBidDetails: updatedData };
      });
      if(sahilcheck){
        setMyCatalogViewData((prevData) => {
          const updatedData = prevData.liveBidDetails.map((item) => {
            if (
              item.auctionItemDetailId === bidSubmittedData?.auctionItemDetailId
            ) {
              const updatedColumnDetails = item.columnDetails.map(
                (columnDetail) => {
                  if (columnDetail.columnTypeId === 10) {
                    columnDetail.columnValue = bidSubmittedData?.buyingQuantity;
                  }
                  return columnDetail;
                }
              );
  
              item.columnDetails = updatedColumnDetails;
            }
            return item;
          });
          return { ...prevData, liveBidDetails: updatedData };
        });
      }
    }
  }, [bidSubmittedData]);
  const s = (o, m) => {
    let buser = o.bidwiseUserId;
    let pp = 0;
    setuserWiseViewEnglishAuctionData((b) => {
      if (!b || !b.liveBidDetails) return b;
      let i = b.liveBidDetails.findIndex((e) => e.auctionItemDetailId === o.auctionItemDetailId);
      if (i === -1) return b;
      let r = { ...b.liveBidDetails[i] };
      r.highestBidPrice = o.highestBidPrice;
      r.status = o.status;
      r.highestBidder = o.highestBidder;
      r.isEnable = o.isReservePriceMet == 1 ? 0 : 1;
      let n = o.highestBidder.find((u) => u.bidderId == userId),
        v = n ? n.rank : null,
        p = false,
        nm = o.hbidderName;
      r.columnDetails = r.columnDetails.map((k) => {
        if(userId==buser){
        if(k.columnTypeId == 35){
          k.columnValue=o.autoBidUser;
        }else if(k.columnTypeId == 36){
          k.columnValue=o.limitpriceUser;
        }
        }
        if(true && k.columnTypeId == 12 && nm != null && nm != ""){
          return{
            ...k,
            columnValue:nm,
          }
        }
        if (
          (k.columnTypeId == 11 || k.columnTypeId == 10 || k.columnTypeId == 34 || k.columnTypeId == 15 || k.columnTypeId == 50) &&
          o.status == 1
        ) {
          if (k.columnTypeId == 10) {
            p = k.columnValue != null && k.columnValue != "" && k.columnValue != undefined && k.columnValue != 0;
          }
          let w = null;
          if (v === 1) w = "custom_GREEN";
          else if (v > 1 && v <= o.divisibleBuyer) w = "custom_ORANGE";
          else if (o.highestBidPrice > 0) w = "custom_BLUE";
          return {
            ...k,
            columnValue: k.columnTypeId == 11 || k.columnTypeId == 34 ? o.highestBidPrice : k.columnTypeId == 50 ? o.buyShare : k.columnValue,
            columnColor: k.columnTypeId == 11 || k.columnTypeId == 10 || k.columnTypeId == 50 ? w : k.columnTypeId == 15 ? (k.columnValue == astatus ? (o.isReservePriceMet == 1 ? "custom_TURQUOISE" : "custom_RED") : k.columnColor) : k.columnColor,
          };
        } else if (
          (k.columnTypeId == 11 || k.columnTypeId == 10 || k.columnTypeId == 15 || k.columnTypeId == 50 || k.columnTypeId == 34) &&
          o.status == 0
        ) {
          let w = v === 1 ? "custom_GREEN" : "custom_BLUE";
          return {
            ...k,
            columnValue: k.columnTypeId == 11 || k.columnTypeId == 34 ? o.highestBidPrice : k.columnTypeId == 50 ? o.buyShare : k.columnValue,
            columnColor: k.columnTypeId == 11 || k.columnTypeId == 10 || k.columnTypeId == 50 ? w : k.columnTypeId == 15 ? (k.columnValue == astatus ? (o.isReservePriceMet == 1 ? "custom_TURQUOISE" : "custom_RED") : k.columnColor) : k.columnColor,
          };
        }
        return k;
      });
      if (p) r.isBQEnable = 0;
      let q = [...b.liveBidDetails.slice(0, i), r, ...b.liveBidDetails.slice(i + 1)];
      return { ...b, liveBidDetails: q };
    });
    if (m) {
      setMyCatalogViewData((b) => {
        if (!b || !b.liveBidDetails) return b;
        let i = b.liveBidDetails.findIndex((e) => e.auctionItemDetailId === o.auctionItemDetailId);
        if (i === -1) return b;
        let r = { ...b.liveBidDetails[i] };
        r.highestBidPrice = o.highestBidPrice;
        r.status = o.status;
        r.highestBidder = o.highestBidder;
        r.isEnable = o.isReservePriceMet == 1 ? 0 : 1;
        let n = o.highestBidder.find((u) => u.bidderId == userId),
          v = n ? n.rank : null,
          p = false,
          nm = o.hbidderName;
        r.columnDetails = r.columnDetails.map((k) => {
          if(k.columnTypeId==13)
            pp=k.columnValue;
          if(AIR){
            if(k.columnTypeId == 48){
              k.columnValue=o.highestBidPrice-pp;
            }
          }
          if(userId==buser){
            if(k.columnTypeId == 35){
              k.columnValue=o.autoBidUser;
            }else if(k.columnTypeId == 36){
              k.columnValue=o.limitpriceUser;
            }
          }
          if(k.columnTypeId == 12 && nm != null && nm != ""){
            return{
              ...k,
              columnValue:nm,
            }
          }
          if (
            (k.columnTypeId == 11 || k.columnTypeId == 10 || k.columnTypeId == 34 || k.columnTypeId == 15 || k.columnTypeId == 50) &&
            o.status == 1
          ) {
            if (k.columnTypeId == 10) {
              p = k.columnValue != null && k.columnValue != "" && k.columnValue != undefined && k.columnValue != 0;
            }
            let w = null;
            if (v === 1) w = "custom_GREEN";
            else if (v > 1 && v <= o.divisibleBuyer) w = "custom_ORANGE";
            else if (o.highestBidPrice > 0) w = "custom_BLUE";
            return {
              ...k,
              columnValue: k.columnTypeId == 11 || k.columnTypeId == 34 ? o.highestBidPrice : k.columnTypeId == 50 ? o.buyShare : k.columnValue,
              columnColor: k.columnTypeId == 11 || k.columnTypeId == 10 || k.columnTypeId == 50 ? w : k.columnTypeId == 15 ? (k.columnValue == astatus ? (o.isReservePriceMet == 1 ? "custom_TURQUOISE" : "custom_RED") : k.columnColor) : k.columnColor,
            };
          } else if (
            (k.columnTypeId == 11 || k.columnTypeId == 10 || k.columnTypeId == 34 || k.columnTypeId == 15 || k.columnTypeId == 50) &&
            o.status == 0
          ) {
            let w = v === 1 ? "custom_GREEN" : "custom_BLUE";
            return {
              ...k,
              columnValue: k.columnTypeId == 11 || k.columnTypeId == 34 ? o.highestBidPrice : k.columnTypeId == 50 ? o.buyShare : k.columnValue,
              columnColor: k.columnTypeId == 11 || k.columnTypeId == 10 || k.columnTypeId == 50 ? w : k.columnTypeId == 15 ? (k.columnValue == astatus ? (o.isReservePriceMet == 1 ? "custom_TURQUOISE" : "custom_RED") : k.columnColor) : k.columnColor,
            };
          }
          return k;
        });
        if (p) r.isBQEnable = 0;
        let q = [...b.liveBidDetails.slice(0, i), r, ...b.liveBidDetails.slice(i + 1)];
        return { ...b, liveBidDetails: q };
      });
    }
  };
    const maxReconnectAttempts = 5; // Limit retries
    const reconnectDelay = 10000; // Start with 2 seconds
    let reconnectAttempts = 0;
  useEffect(() => {
    let stomp = null;
    let reconnectTimeout = null;
    const socketHandler = () => {
      let url =
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_END_POINT_URL_DEV
          : process.env.REACT_APP_END_POINT_URL_PROD;

      const socket = new SockJS(
        url +
          "/englishauction/connect?token=" +
          atob(sessionStorage.getItem("argument1"))
      );

      stomp = Stomp.over(socket);
      stomp.debug = null;
      setStompClient(stomp);

      const subscribeCall = (stomp) => {
        stomp.subscribe(
          "/englishauction/broadcast/getlivebiddata/" + auctionDetailId,
          (message) => {
            if (message.body) {
              dispatch(
                actionUrl.viewBidRequest({
                  auctionDetailId: auctionDetailId,
                  userLoginId: userId,
                })
              );
              if (AuctioneerCodeSocket) {
                dispatch(
                  actionUrl.getViewTeaSoldMarketIdAction({
                    auctionDetailId: auctionDetailId,
                    commonUserId: commonUserIdSocket,
                  })
                );
              }
              switch (activeTab) {
                case 1:
                  dispatch(
                    actionUrl.MyCatalogViewIdAction({
                      auctionDetailId: auctionDetailId,
                      userLoginId: userId,
                    })
                  );
                  break;

                case 2:
                  dispatch(
                    actionUrl.getMyplannerIdAction({
                      auctionDetailId: auctionDetailId,
                      commonUserId: userId,
                    })
                  );
                  break;

                // case 3:
                //   dispatch(actionUrl.getViewTeaSoldIdAction(auctionDetailId));
                //   dispatch(actionUrl.getauctioneerIdAction(auctionDetailId));
                //   dispatch(
                //     actionUrl.getviewmarketsummaryIdAction(auctionDetailId)
                //   );
                //   break;

                case 4:
                  dispatch(
                    actionUrl.getMarketDepthIdAction({
                      auctionDetailId: auctionDetailId,
                      auctionItemDetailId: itemIDAuc,
                      userLoginId: userId,
                    })
                  );
                  break;

                default:
                  // Handle the case where activeTab is null or an invalid value
                  console.log("No valid tab is active.");
                  break;
              }
            }
          }
        );
        stomp.subscribe(
          "/englishauction/broadcast/rpupdate/" + auctionDetailId,
          (message) => {
            if (message.body) {
              try{
              let rowDetails = parseInt(message.body.split("$$")[0]);
              let rrpvalue = parseInt(message.body.split("$$")[1]);
              let tor_color = parseInt(message.body.split("$$")[2]);
              setMyCatalogViewData((prevData) => {
                const updatedData = prevData?.liveBidDetails?.map((item) => {
                  if (item.auctionItemDetailId == rowDetails) {
                    const updatedColumnDetails = item?.columnDetails.map((columnDetail) => {
                      if (columnDetail.columnTypeId === 13) {
                        // Update column value (RP) with the new value from alertMessage
                        columnDetail.columnValue = rrpvalue;
                      }else if(columnDetail.columnTypeId == 15){
                        if(tor_color==1){
                          columnDetail.columnColor="custom_TURQUOISE";
                        }
                      }
                      return columnDetail;
                    });
        
                    item.columnDetails = updatedColumnDetails;
                  }
                  return item;
                });
                return {...prevData, liveBidDetails: updatedData};
              });
      
              setuserWiseViewEnglishAuctionData((prevData) => {
                const updatedData = prevData?.liveBidDetails.map((item) => {
                  if (item.auctionItemDetailId == rowDetails) {
                    const updatedColumnDetails = item?.columnDetails.map((columnDetail) => {
                      if (columnDetail.columnTypeId === 13) {
                        columnDetail.columnValue = rrpvalue;
                      }
                      return columnDetail;
                    });
        
                    item.columnDetails = updatedColumnDetails;
                  }
                  return item;
                });
                return {...prevData, liveBidDetails: updatedData};
              })
              // dispatch(
              //   actionUrl.viewBidRequest({
              //     auctionDetailId: auctionDetailId,
              //     userLoginId: userId,
              //   })
              // );
              // if (AuctioneerCodeSocket) {
              //   dispatch(
              //     actionUrl.getViewTeaSoldMarketIdAction({
              //       auctionDetailId: auctionDetailId,
              //       commonUserId: commonUserIdSocket,
              //     })
              //   );
              // }
              // switch (activeTab) {
              //   case 1:
              //     dispatch(
              //       actionUrl.MyCatalogViewIdAction({
              //         auctionDetailId: auctionDetailId,
              //         userLoginId: userId,
              //       })
              //     );
              //     break;

              //   case 2:
              //     dispatch(
              //       actionUrl.getMyplannerIdAction({
              //         auctionDetailId: auctionDetailId,
              //         commonUserId: userId,
              //       })
              //     );
              //     break;

              //   // case 3:
              //   //   dispatch(actionUrl.getViewTeaSoldIdAction(auctionDetailId));
              //   //   dispatch(actionUrl.getauctioneerIdAction(auctionDetailId));
              //   //   dispatch(
              //   //     actionUrl.getviewmarketsummaryIdAction(auctionDetailId)
              //   //   );
              //   //   break;

              //   case 4:
              //     dispatch(
              //       actionUrl.getMarketDepthIdAction({
              //         auctionDetailId: auctionDetailId,
              //         auctionItemDetailId: itemIDAuc,
              //         userLoginId: userId,
              //       })
              //     );
              //     break;

              //   default:
              //     // Handle the case where activeTab is null or an invalid value
              //     console.log("No valid tab is active.");
              //     break;
              // }
            }catch(error){
              console.log(error);
            }
          }
          }
        );
        stomp.subscribe(
          "/englishauction/broadcast/modifiedBy/" +
            userId +
            "/" +
            auctionDetailId,
            (message) => {
              if (message.body) {
                let rowDetails = parseInt(message.body.split("$$")[0]);
                let modifiedBy = message.body.split("$$")[1];
                setMyCatalogViewData((prevData) => {
                  const updatedData = prevData?.liveBidDetails.map((item) => {
                    if (item.auctionItemDetailId == rowDetails) {
                      const updatedColumnDetails = item?.columnDetails.map((columnDetail) => {
                        if (columnDetail.columnTypeId === 46) {
                          columnDetail.columnValue = modifiedBy;
                        }
                        return columnDetail;
                      });
          
                      item.columnDetails = updatedColumnDetails;
                    }
                    return item;
                  });
                  return {...prevData, liveBidDetails: updatedData};
                });
        
                setuserWiseViewEnglishAuctionData((prevData) => {
                  const updatedData = prevData?.liveBidDetails.map((item) => {
                    if (item.auctionItemDetailId == rowDetails) {
                      const updatedColumnDetails = item?.columnDetails.map((columnDetail) => {
                        if (columnDetail.columnTypeId === 46) {
                          columnDetail.columnValue = modifiedBy;
                        }
                        return columnDetail;
                      });
          
                      item.columnDetails = updatedColumnDetails;
                    }
                    return item;
                  });
                  return {...prevData, liveBidDetails: updatedData};
                })
                
              }
            });
            stomp.subscribe(
              `/englishauction/broadcast/knockdownsolddata/${auctionDetailId}`,
              (msg) => {
                try{
                if (!msg.body) return;
                let j = JSON.parse(msg.body),
                  w = j[0]?.winbidder || [];
                userId && w.includes(+userId) &&
                  setMyCatalogViewData((p = { liveBidDetails: [] }) => {
                    if (!p?.liveBidDetails) return p;
                    return {
                      ...p,
                      liveBidDetails: p.liveBidDetails.map((r) => {
                        let r1 = j.find((x) => x.auctionItemDetailId === r.auctionItemDetailId);

                        return r1 ? { ...r, columnDetails: Ucd(r, r1) } : r;
                      }),
                    };
                  });
              }catch(error){
                console.log(error);
              }}
            );
            
            
        stomp.subscribe(
          `/englishauction/broadcast/bidsubmited/${auctionDetailId}`,
          (message) => {
            if (message.body) {
              try{
                let n = JSON.parse(message.body);
                s(n, sahilcheck);
            } catch(error){
              console.log(error);
            }
          }
          }
        );
        stomp.subscribe(
          `/englishauction/broadcast/getactivedata/${auctionDetailId}`,
          (message) => {
            if (!message.body) return;
            try {
              const json = JSON.parse(message.body);
              const pu = (pppppppp) => {
                if (!pppppppp || !pppppppp.liveBidDetails) return pppppppp;
                const ulbd = json.rowDetails.map((detail) => {
                  const row = pppppppp.liveBidDetails.find(
                    (row) => row.auctionItemDetailId === detail.auctionItemDetailId
                  );
                  if (!row) return null;
                  const UB = detail.highestBidderRank?.find((b) => b.bidderId == userId),
                  ur = UB?.rank ?? null;

                  let cc = ur === 1 ? "custom_GREEN" : (ur > 1 && ur <= detail.divisibleBuyer) ? "custom_ORANGE" : "";
                  let dbq = false;

                  if (detail.status === astatus) {
                    row.columnDetails.forEach((column) => {
                      if (column.columnTypeId == 10) {
                        dbq =
                          column.columnValue && column.columnValue !== 0 ? true : false;
                      }
                    });
                    if (dbq) row.isBQEnable = 0;
                  }
                  return {
                    ...row,
                    columnDetails: ucd(row, detail.status, detail.colourFlag,detail.highestBidder,cc),
                  };
                }).filter(Boolean);
                return { ...pppppppp, liveBidDetails: ulbd };
              };
              sahilcheck && setMyCatalogViewData(pu);
              setuserWiseViewEnglishAuctionData(pu);
              switch (activeTab) {
                

                case 2:
                  dispatch(
                    actionUrl.getMyplannerIdAction({
                      auctionDetailId: auctionDetailId,
                      commonUserId: userId,
                    })
                  );
                  break;

                case 3:
                  dispatch(actionUrl.getViewTeaSoldIdAction(auctionDetailId));
                  dispatch(actionUrl.getauctioneerIdAction(auctionDetailId));
                  dispatch(
                    actionUrl.getviewmarketsummaryIdAction(auctionDetailId)
                  );
                  dispatch(
                    actionUrl.getViewTeaSoldMarketIdAction({
                      auctionDetailId: auctionDetailId,
                      commonUserId: commonUserIdSocket,
                    })
                  );
                  break;

                case 4:
                  dispatch(
                    actionUrl.getMarketDepthIdAction({
                      auctionDetailId: auctionDetailId,
                      auctionItemDetailId: itemIDAuc,
                      userLoginId: userId,
                    })
                  );
                  break;

                default:
                  // Handle the case where activeTab is null or an invalid value
                  console.log("No valid tab is active.");
                  break;
              }
            } catch (error) {
              console.log(error);
            }
          }
        );
        const Ucd = (r, r1) =>
          r?.columnDetails?.map((c) => ({
            ...c,
            columnColor: c.columnTypeId - 1 || !r1?.winningBidders?.includes(+userId) 
              ? c.columnColor 
              : "custom_CORAL",
          })) ?? [];
        const ucd = (row, s, up_rp,hb,cc) =>
          row.columnDetails.map((cl) => {
            if (cl.columnTypeId == 15) {
              return {
                ...cl,
                columnValue: s,
                columnColor: s === astatus ? (up_rp === 0 ? "custom_RED" : "custom_TURQUOISE") : "",
              };
            }
            if (s === astatus && ![11, 10, 50].includes(cl.columnTypeId)) {
              return { ...cl, columnColor: "custom_RED" };
            }
            else if (cc != "" && s === astatus && [11, 10, 50].includes(cl.columnTypeId)) {
              if([11,10,50].includes(cl.columnTypeId)){
                return { ...cl, columnColor: cc };
              }
              if(cl.columnColor == undefined || cl.columnColor == null || cl.columnColor == ""){
                return { ...cl, columnColor: "custom_RED" };
              }
            }
            else if((cc == undefined || cc=="" || cc==null) && s === astatus && [11, 10, 50].includes(cl.columnTypeId)){
              return { ...cl, columnColor: "custom_RED" };
            }
            if (s !== "Sold" && s !== "Un sold") {
              return cl;
            }

            if((s == "Sold" || s == "Un sold") && cl.columnTypeId == 12){
              return { ...cl, columnValue: hb, columnColor: "" };
            }
            if((s == "Sold" || s == "Un sold") && cl.columnTypeId == 1){
              return { ...cl,  columnColor: cl.columnColor == "custom_CORAL" ? cl.columnColor : "" };
            }
            return { ...cl, columnColor: "" };
          });
        
        stomp.subscribe(
          "/englishauction/broadcast/holdAuction/" + auctionDetailId,
          (message) => {
            if (message.body) {
              dispatch(
                actionUrl.fetchEnglishAuctionHeaderDataRequest(auctionDetailId)
              );
              dispatch(
                actionUrl.viewUserWiseLiveEnglishAuctionRequest({
                  auctionDetailId: auctionDetailId,
                  userLoginId: userId,
                  sahilset: 1,
                })
              );
              CustomToast.info(message.body);
            }
          }
        );
        stomp.subscribe(
          "/englishauction/broadcast/auctionstartnotify/" +
            auctionCenterIdFromURI,
          (message) => {
            if (message.body) {
              let newId = parseInt(message.body.split("$$")[1]);
              CustomToast.info(message.body.split("$$")[0]);
              let url =
                "/englishauction/" +
                btoa(newId) +
                "/" +
                window.location.pathname.split("/")[3] +
                "/" +
                window.location.pathname.split("/")[4] +
                "/" +
                window.location.pathname.split("/")[5];
              if (
                window.location.pathname.split("/")[4] != undefined &&
                window.location.pathname.split("/")[5] != undefined &&
                window.location.pathname.split("/")[3] != undefined &&
                auctionDetailId != newId
              ) {
                const userConfirmed = window.confirm(
                  "Your new sassion has stared. Do you want to redirect? \n\n Note : If you select cancel you need to go back to dashboard and select auction center for live auction session."
                );
                // Redirect to the new URL
                if (userConfirmed) {
                  // Redirect to the new URL
                  window.location.href = url;
                }
              }
            }
          }
        );
        stomp.subscribe(
          "/englishauction/broadcast/ResumeAuction/" + auctionDetailId,
          (message) => {
            if (message.body) {
              if (message.body == "Session Start") {
                CustomToast.info(message.body);
              }
              
              dispatch(
                actionUrl.fetchEnglishAuctionHeaderDataRequest(auctionDetailId)
              );
              dispatch(
                actionUrl.viewUserWiseLiveEnglishAuctionRequest({
                  auctionDetailId: auctionDetailId,
                  userLoginId: userId,
                  sahilset: 1,
                })
              );
              console.log("activeTab1212", activeTab);
              switch (activeTab) {
                case 1:
                  dispatch(
                    actionUrl.MyCatalogViewIdAction({
                      auctionDetailId: auctionDetailId,
                      userLoginId: userId,
                    })
                  );
                  break;

                case 2:
                  dispatch(
                    actionUrl.getMyplannerIdAction({
                      auctionDetailId: auctionDetailId,
                      commonUserId: userId,
                    })
                  );
                  break;

                case 3:
                  dispatch(actionUrl.getViewTeaSoldIdAction(auctionDetailId));
                  dispatch(actionUrl.getauctioneerIdAction(auctionDetailId));
                  dispatch(
                    actionUrl.getviewmarketsummaryIdAction(auctionDetailId)
                  );
                  break;

                case 4:
                  dispatch(
                    actionUrl.getMarketDepthIdAction({
                      auctionDetailId: auctionDetailId,
                      auctionItemDetailId: itemIDAuc,
                      userLoginId: userId,
                    })
                  );
                  break;

                default:
                  // Handle the case where activeTab is null or an invalid value
                  console.log("No valid tab is active.");
                  break;
              }
            }
          }
        );
        stomp.subscribe(
          "/englishauction/broadcast/newAuctionStart/" + auctionCenterIdFromURI,
          (message) => {
            if (message.body) {
              if (
                window.location.pathname.split("/")[4] != undefined &&
                window.location.pathname.split("/")[5] != undefined &&
                window.location.pathname.split("/")[3] != undefined
              )
                CustomToast.info(message.body);
            }
          }
        );
        stomp.subscribe(
          "/englishauction/broadcast/auctionStart/" + auctionDetailId,
          (message) => {
            if (message.body) {
              if (
                window.location.pathname.split("/")[4] != undefined &&
                window.location.pathname.split("/")[5] != undefined &&
                window.location.pathname.split("/")[3] != undefined
              )
                CustomToast.info(message.body);
            }
          }
        );
        stomp.subscribe(
          "/englishauction/broadcast/auctionend/" + auctionDetailId,
          (message) => {
            if (message.body) {
              if (
                window.location.pathname.split("/")[4] != undefined &&
                window.location.pathname.split("/")[5] != undefined &&
                window.location.pathname.split("/")[3] != undefined
              )
                CustomToast.info(message.body);
            }
          }
        );
      };

      // Connect to the WebSocket server
      stomp.connect({}, () => {
        console.log("✅ WebSocket connected");
        subscribeCall(stomp);
        reconnectAttempts = 0;
      },handleWebSocketError);
    };
    const handleWebSocketError = (error) => {
      console.error("❌ WebSocket error:", error);
      CustomToast.error("Connection issue detected. Attempting to reconnect...")
      attemptReconnect();
    };
    const attemptReconnect = () => {
      if (reconnectAttempts < maxReconnectAttempts) {
        const delay = reconnectDelay * (1); // Exponential backoff
        CustomToast.info(`🔄 Attempting reconnect in ${delay / 1000} seconds...`);
        reconnectAttempts = reconnectAttempts + 1;
        reconnectTimeout = setTimeout(socketHandler, delay);
      } else {
        CustomToast.error("🚨 Maximum reconnect attempts reached. Stopping retries.");
        // (stompClient) stompClient.disconnect();
      }
    };

    if (
      userWiseViewEnglishAuctionData != null &&
      userWiseViewEnglishAuctionData != undefined
    ) {
      socketHandler();
    }

    return () => {
      if (stomp) stomp.disconnect();
      if (reconnectTimeout) clearTimeout(reconnectTimeout);
    };
  }, []);

  useEffect(() => {
    if (
      bidsubmitted !== undefined &&
      bidsubmitted.length !== 0 && // check if bidsubmitted is not an empty array
      stompClient !== undefined // check if stompClient is defined
    ) {
      // stompClient.send("/englishauction/send/addbid", {}, auctionDetailId);
      dispatch(actionUrl.lotWiseBidAcceptSuccess([]));
    }
  }, [bidsubmitted, stompClient]);

  useEffect(() => {
    let leftColumnsArray = [];
    if (Number.isInteger(leftNo) && leftNo > 0) {
      leftColumnsArray = [...Array(leftNo)]?.map(
        (_, index) => fixedColumns[index].name
      );
      setLeftData(leftColumnsArray);
    } else {
      //locked data get from api
      let length = fixedColumns.length / 2;
      for (let i = 0; i < fixedColumns.length; i++) {
        if (i < length) {
          if (1 == fixedColumns[i].isLocked) {
            leftColumnsArray.push(fixedColumns[i].name);
          }
        }
      }
      setLeftDbData(leftColumnsArray);
      setLeftData(leftColumnsArray);
    }

    setLeftColumns(leftColumnsArray);
  }, [leftNo, fixedColumns]);
  //change

  const handleButtonChangePrice = (auctionItemDetailId, column) => {
    setAuctionItemRowId(auctionItemDetailId)
    dispatch(isRpButtonClickedTrue())
    let Rpvalue = "";
    column?.forEach((row) => {
      if (row.columnTypeId === 48) {
        Rpvalue = row.columnValue;
      }
    });

    dispatch(
      actionUrl.ChangeReservePriceAction({
        auctionDetailId: auctionDetailId,
        auctionItemDetailIds: [
          {
            auctionItemDetailId: auctionItemDetailId,
            newRP: Rpvalue,
          },
        ],
        isManualCheck: 0
      })
    );
    // setshowListMsg(true);
  };

  const handleButton = (RP, data, row) => {
    data = row;
    let maxBid = 0;
    let bidPrice = 0;
    let autoBid = 0;
    let limitPrice = 0;
    let basePrice = 0;
    let lotNo = "";
    let noOfPackages = "";

    let sharingQuantity = "";
    let buyingQuantity = "";
    let auctionCenterId = "";
    let season = englishHauctionHeaderdata.season;
    let saleNo = englishHauctionHeaderdata.saleNo;
    let categoryId = row?.categoryId;
    let HBP = 0;
    let BasePrice = 0;
    let percentage = 0;
    percentage = row?.permissibleBidLimitPercentage;
    data &&
      data.columnDetails &&
      data.columnDetails.map((columnDetailsData, columnDetailsIndex) => {
        if (11 == columnDetailsData.columnTypeId) {
          HBP = columnDetailsData.columnValue;
        }
        if (9 == columnDetailsData.columnTypeId) {
          BasePrice = columnDetailsData.columnValue;
        }
        if (34 == columnDetailsData.columnTypeId) {
          bidPrice = columnDetailsData.columnValue;
        }
        if (35 == columnDetailsData.columnTypeId) {
          autoBid = columnDetailsData.columnValue;
        }
        if (36 == columnDetailsData.columnTypeId) {
          limitPrice = columnDetailsData.columnValue;
        }
        if (9 == columnDetailsData.columnTypeId) {
          basePrice = columnDetailsData.columnValue;
        }
        if (1 == columnDetailsData.columnTypeId) {
          lotNo = columnDetailsData.columnValue;
        }

        if (8 == columnDetailsData.columnTypeId) {
          noOfPackages = columnDetailsData.columnValue;
        }
        if (31 == columnDetailsData.columnTypeId) {
          sharingQuantity = columnDetailsData.columnValue;
        }
        if (32 == columnDetailsData.columnTypeId) {
          buyingQuantity = columnDetailsData.columnValue;
        }
        if (37 == columnDetailsData.columnTypeId) {
          maxBid = columnDetailsData.columnValue;
        }
      });
    data &&
      data.columnDetails &&
      data.columnDetails.map((columnDetailsData, columnDetailsIndex) => {
        if (42 == columnDetailsData.columnTypeId) {
          maxBid = columnDetailsData.columnValue;
        }
      });
    if (HBP == 0) {
      HBP = BasePrice;
    }
    if (
      (parseInt(limitPrice) < parseInt(bidPrice) ||
        parseInt(limitPrice) < parseInt(autoBid)) &&
      parseInt(limitPrice) != 0
    ) {
      const confirmation = window.confirm(
        "Limit price is less then AutoBid price or Bid price. Do you want to continue?"
      );
      if (!confirmation) {
        return; // Don't proceed with the bid
      }
    }
    HBP = HBP + (parseInt(HBP) * parseInt(percentage)) / 100;
    if (parseInt(bidPrice) > HBP) {
      const confirmation = window.confirm(
        "Your bid is more than the acceptable range. Do you want to continue?"
      );
      if (!confirmation) {
        return; // Don't proceed with the bid
      }
    }
    limitPrice = limitPrice == null ? 0 : limitPrice;
    autoBid = autoBid == null ? 0 : autoBid;
    bidPrice = bidPrice == "" ? 0 : bidPrice;
    let payloadData = {
      maxBid: maxBid,
      bidPrice: bidPrice,
      autoBid: Number(autoBid),
      limitPrice: Number(limitPrice),
      basePrice: Number(basePrice),
      lotNo: lotNo,
      noOfPackages: noOfPackages,
      sharingQuantity: sharingQuantity,
      buyingQuantity: Number(buyingQuantity),
      auctionCenterId: auctionCenterIdFromURI,
      season: season,
      saleNo: saleNo,
      categoryId: categoryId,
      sameRP: RP,
      auctionItemDetailId: data.auctionItemDetailId,
      bidderId: userId,
      auctionDetailId: auctionDetailId,
    };
    dispatch(actionUrl.lotWiseBidAcceptRequest(payloadData));
  };
  const handleButtonCatalog = (RP, data, row) => {
    data = row;
    let maxBid = 0;
    let bidPrice = 0;
    let autoBid = 0;
    let limitPrice = 0;
    let basePrice = 0;
    let lotNo = "";
    let noOfPackages = "";

    let sharingQuantity = "";
    let buyingQuantity = "";
    let auctionCenterId = "";
    let season = englishHauctionHeaderdata.season;
    let saleNo = englishHauctionHeaderdata.saleNo;
    let categoryId = row?.categoryId;

    data &&
      data.columnDetails &&
      data.columnDetails.map((columnDetailsDataCatalog, columnDetailsIndex) => {
        if (34 == columnDetailsDataCatalog.columnTypeId && RP != 1) {
          bidPrice =
            columnDetailsDataCatalog.columnValue == null
              ? 0
              : columnDetailsDataCatalog.columnValue;
        }
        if (35 == columnDetailsDataCatalog.columnTypeId) {
          autoBid =
            columnDetailsDataCatalog.columnValue == null
              ? 0
              : columnDetailsDataCatalog.columnValue;
        }
        if (36 == columnDetailsDataCatalog.columnTypeId) {
          limitPrice =
            columnDetailsDataCatalog.columnValue == null
              ? 0
              : columnDetailsDataCatalog.columnValue;
        }
        if (9 == columnDetailsDataCatalog.columnTypeId) {
          basePrice =
            columnDetailsDataCatalog.columnValue == null
              ? 0
              : columnDetailsDataCatalog.columnValue;
        }
        if (1 == columnDetailsDataCatalog.columnTypeId) {
          lotNo =
            columnDetailsDataCatalog.columnValue == null
              ? 0
              : columnDetailsDataCatalog.columnValue;
        }

        if (8 == columnDetailsDataCatalog.columnTypeId) {
          noOfPackages =
            columnDetailsDataCatalog.columnValue == null
              ? 0
              : columnDetailsDataCatalog.columnValue;
        }
        if (31 == columnDetailsDataCatalog.columnTypeId) {
          sharingQuantity =
            columnDetailsDataCatalog.columnValue == null
              ? 0
              : columnDetailsDataCatalog.columnValue;
        }
        if (32 == columnDetailsDataCatalog.columnTypeId) {
          buyingQuantity =
            columnDetailsDataCatalog.columnValue == null
              ? 0
              : columnDetailsDataCatalog.columnValue;
        }
        if (37 == columnDetailsDataCatalog.columnTypeId) {
          maxBid =
            columnDetailsDataCatalog.columnValue == null
              ? 0
              : columnDetailsDataCatalog.columnValue;
        }
        if (RP == 1 && columnDetailsDataCatalog.columnTypeId == 13) {
          bidPrice =
            columnDetailsDataCatalog.columnValue == null
              ? 0
              : columnDetailsDataCatalog.columnValue;
        }
      });
    data &&
      data.columnDetails &&
      data.columnDetails.map((columnDetailsDataCatalog, columnDetailsIndex) => {
        if (42 == columnDetailsDataCatalog.columnTypeId) {
          maxBid =
            columnDetailsDataCatalog.columnValue == null
              ? 0
              : columnDetailsDataCatalog.columnValue;
        }
      });

    let payloadData = {
      maxBid: maxBid,
      bidPrice: bidPrice == '' ? 0 : bidPrice,
      autoBid: autoBid == '' ? 0 : autoBid,
      limitPrice: limitPrice == '' ? 0 : limitPrice,
      basePrice: basePrice,
      lotNo: lotNo,
      noOfPackages: noOfPackages,
      sharingQuantity: sharingQuantity,
      buyingQuantity: buyingQuantity,
      auctionCenterId: auctionCenterIdFromURI,
      season: season,
      saleNo: saleNo,
      categoryId: categoryId,
      sameRP: RP,
      auctionItemDetailId: data.auctionItemDetailId,
      bidderId: userId,
      auctionDetailId: auctionDetailId,
    };
    dispatch(actionUrl.lotWiseBidAcceptRequest(payloadData));
  };

  const handleMarketDepth = (auctionItemDetailId) => {
    activeTab = 4;
    setauctionItemId(auctionItemDetailId);
    itemIDAuc = auctionItemDetailId;
    setshowMarketDepth(true);
    // setmyplanner(false);
    // setmyCatalog(false);
    // setShowSideSlide(false);
    dispatch(
      actionUrl.getMarketDepthIdAction({
        auctionDetailId: auctionDetailId,
        auctionItemDetailId: auctionItemDetailId,
        userLoginId: userId,
      })
    );
  };
  const handleDefaultButton = () => {
    setLoader(true);
    dispatch(
      actionUrl.DefaultCloumnConfigAction({
        auctionDetailId: auctionDetailId,
        userLoginId: userId,
      })
    );

    // CustomToast.success(" Restore Defaults Catalog Configured successfully");
  };
  const handleDefaultButtonLiveAuction = () => {
    dispatch(
      actionUrl.initiateAddCatalogColumnConfig({
        auctionDetailId: auctionDetailId,
        userLoginId: userId,
      })
    );
  };
  const handleAddRemoveButton = (name, data) => {
    switch (name) {
      case "RemoveMyCatalogAction": {
        if (selectedRowsRemove.length === 0) {
          toast.error("Please select at least one Lot No.");
          return;
        }
        let payloadData = {
          auctionItemDetails: selectedRowsRemove,
          auctionDetailId: auctionDetailId,
          userLoginId: userId,
          isActive: 1,
        };
        setLoader(true);
        dispatch(actionUrl.RemoveMyCatalogAction(payloadData));
        setSelectedRowsRemove([]);
        break;
      }

      case "AddMyCatalogAction": {
        if (selectedRows.length === 0) {
          toast.error("Please select at least one Lot No.");
          return;
        }
        let payloadData = {
          auctionItemDetails: selectedRows,
          auctionDetailId: auctionDetailId,
          userLoginId: userId,
          isActive: 1,
        };
        setLoader(true);
        dispatch(actionUrl.AddMyCatalogAction(payloadData));
        setSelectedRows([]);
        break;
      }

      default: {
        break;
      }
    }
  };
  const handleAddRemoveButtonViewBidBook = (name, data) => {
    let itemId = null;
    switch (name) {
      case "AddMyCatalogAction": {
        if (userRoleCode == "TAOUSER" || userRoleCode == "TEABOARDUSER") {
          if (selectedRows.length === 0) {
            toast.error("Please select one Lot No.");
            return;
          } else if (selectedRows.length > 1) {
            toast.error("Please select only one Lot No.");
            return;
          } else {
            itemId = selectedRows[0];
            setitemIdExport(selectedRows[0]);
          }
        }
        let payloadData = {
          auctionDetailId: auctionDetailId,
          commonUserId: userId,
          lotNo: null,
          markId: null,
          gradeId: null,
          lotStatus: null,
          sessionTime: null,
          auctionItemDetailId: itemId,
          isLiveBidBook: 1,
          auctionCenterId: auctionCenterIdFromURI,
          isfirstcall: true,
        };
        dispatch(actionUrl.fetchBidBookRequest(payloadData));
        setSelectedRows([]);
        setbidbookShow(true);
        break;
      }

      default: {
        break;
      }
    }
  };

  const handleChangeGroupCode = (event) => {
    const { name, value } = event.target;
    let errorMessage = "";

    if (name === "valuation") {
      // Validation for My Valuation
      const validatedValue = value.replace(/[^\d]/g, "").slice(0, 20);
      if (validatedValue !== value) {
        errorMessage =
          "Only numeric characters without decimal, maximum 20 characters";
      }
      setFormData({
        ...formData,
        myValuation: validatedValue,
      });
      setValidationErrors({
        ...validationErrors,
        myValuation: errorMessage,
      });
    } else if (name === "comments") {
      // Validation for My Comments
      const validatedValue = value.slice(0, 1000);
      if (validatedValue !== value) {
        errorMessage = "Maximum 1000 characters allowed";
      }
      setFormData({
        ...formData,
        myComments: validatedValue,
      });
      setValidationErrors({
        ...validationErrors,
        myComments: errorMessage,
      });
    } else if (name === "groupCode") {
      setFormData((prevData) => ({
        ...prevData,
        groupCode: value,
      }));
      setgroupCode11(value);
    } else if (name === "comments") {
      setFormData((prevData) => ({
        ...prevData,
        myComments: value,
      }));
      // setComments11(value);
    } else if (name === "valuation") {
      setFormData((prevData) => ({
        ...prevData,
        myValuation: value,
      }));
      // setvaluation11(value);
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };
  const handleChange = (
    data,
    auctionItemDetailId,
    columnTypeId,
    value,
    key
  ) => {
    if (!/^\d*$/.test(value)) {
      return;
    }
    let QtyVal = 0;

    userWiseViewEnglishAuctionData.liveBidDetails.map(
      (liveBidDetailsData, liveBidDetailsIndex) => {
        if (auctionItemDetailId == liveBidDetailsData.auctionItemDetailId) {
          liveBidDetailsData &&
            liveBidDetailsData.columnDetails &&
            liveBidDetailsData.columnDetails.map(
              (columnDetailsData, columnDetailsIndex) => {
                if (8 == columnDetailsData.columnTypeId) {
                  QtyVal = columnDetailsData["columnValue"];
                }

                if (columnTypeId == columnDetailsData.columnTypeId) {
                  if (columnDetailsData.columnTypeId == 32) {
                    if (value >= 0) {
                      columnDetailsData[key] = value > QtyVal ? QtyVal : value;
                    }
                  } else {
                    if (value >= 0) {
                      columnDetailsData[key] = value;
                    }
                  }
                }
                if (
                  columnTypeId == 32 &&
                  columnDetailsData.columnTypeId == 31
                ) {
                  if (value >= 0) {
                    columnDetailsData[key] =
                      QtyVal > value ? QtyVal - value : 0;
                  }
                }
                return columnDetailsData;
              }
            );
        }
      }
    );
    settruefalse(!truefalse);
  };

  const handleChangeCatalog = (
    data,
    auctionItemDetailId,
    columnTypeId,
    value,
    key
  ) => {
    if (!/^\d*$/.test(value)) {
      return;
    }
    let QtyVal = 0;
    myCatalogViewdata.liveBidDetails.map(
      (liveBidDetailsDataCatalog, liveBidDetailsIndex) => {
        if (
          auctionItemDetailId == liveBidDetailsDataCatalog.auctionItemDetailId
        ) {
          liveBidDetailsDataCatalog &&
            liveBidDetailsDataCatalog.columnDetails &&
            liveBidDetailsDataCatalog.columnDetails.map(
              (columnDetailsDataCatalog, columnDetailsIndex) => {
                if (8 == columnDetailsDataCatalog.columnTypeId) {
                  QtyVal = columnDetailsDataCatalog["columnValue"];
                }
                if (columnTypeId == columnDetailsDataCatalog.columnTypeId) {
                  if (columnDetailsDataCatalog.columnTypeId == 32) {
                    if (value >= 0) {
                      columnDetailsDataCatalog[key] =
                        value > QtyVal ? QtyVal : value;
                    }
                  } else {
                    if (value >= 0) {
                      columnDetailsDataCatalog[key] = value;
                    }
                  }
                }
                if (
                  columnTypeId == 32 &&
                  columnDetailsDataCatalog.columnTypeId == 31
                ) {
                  if (value >= 0) {
                    columnDetailsDataCatalog[key] =
                      QtyVal > value ? QtyVal - value : 0;
                  }
                }
                return columnDetailsDataCatalog;
              }
            );
        }
      }
    );
    settruefalse(!truefalse);
  };

  useEffect(() => {
    let rightColumnsArray = [];
    if (Number.isInteger(rightNo) && rightNo > 0) {
      rightColumnsArray = [...Array(rightNo)]?.map(
        (_, index) => lastIndex[index].name
      );
      setRightData(rightColumnsArray);
    } else {
      //locked data get from api
      let length = fixedColumns.length / 2;
      for (let i = fixedColumns.length - 1; i > 0; i--) {
        if (length < i) {
          if (1 == fixedColumns[i].isLocked) {
            rightColumnsArray.push(fixedColumns[i].name);
          }
        }
      }
      setRightDbData(rightColumnsArray);
      setRightData(rightColumnsArray);
    }
    setRightColumns(rightColumnsArray);
  }, [rightNo, fixedColumns]);

  const CalculateRemainingLotTime = (lotSec) => {
    let currentDate = new Date();
    let auctionDate = new Date().getTime() + lotSec * 1000;
    let date1 = new Date(currentDate);
    let date3 = new Date(auctionDate);

    // Calculate the time difference in milliseconds
    let timeDifferenceOfCurrentAndAuctionDate = 1;
    timeDifferenceOfCurrentAndAuctionDate = date3 - date1;
    // Convert the time difference to a more human-readable format
    let seconds = Math.floor(
      (timeDifferenceOfCurrentAndAuctionDate / 1000) % 60
    );

    let minutes = Math.floor(
      (timeDifferenceOfCurrentAndAuctionDate / (1000 * 60)) % 60
    );

    let hours = Math.floor(
      (timeDifferenceOfCurrentAndAuctionDate / (1000 * 60 * 60)) % 24
    );

    if (hours <= 0 && minutes <= 0 && seconds <= 0) {
      lotRemainingTime.setHours(0);
      lotRemainingTime.setMinutes(0);
      lotRemainingTime.setSeconds(0);
      isTimeAvailable = false;
    } else {
      lotRemainingTime.setHours(time.getHours() + hours);
      lotRemainingTime.setMinutes(time.getMinutes() + minutes);
      lotRemainingTime.setSeconds(time.getSeconds() + seconds);
      isTimeAvailable = true;
    }
  };

  const CalculateDifferenceBetweenCurrentTimeAndMBTTime = (
    currentDate,
    auctionDate,
    minimumBidTime
  ) => {
    let date1 = new Date(currentDate);
    let date2 = new Date(minimumBidTime);
    let date3 = new Date(auctionDate);

    // Calculate the time difference in milliseconds
    let timeDifferenceOfCurrentAndAuctionDate = 1;
    if (date1.getTime() > date2.getTime()) {
      timeDifferenceOfCurrentAndAuctionDate = date3 - date1;
    } else {
      timeDifferenceOfCurrentAndAuctionDate = date3 - date2;
    }

    // Convert the time difference to a more human-readable format
    let seconds = Math.floor(
      (timeDifferenceOfCurrentAndAuctionDate / 1000) % 60
    );

    let minutes = Math.floor(
      (timeDifferenceOfCurrentAndAuctionDate / (1000 * 60)) % 60
    );

    let hours = Math.floor(
      (timeDifferenceOfCurrentAndAuctionDate / (1000 * 60 * 60)) % 24
    );

    if (hours <= 0 && minutes <= 0 && seconds <= 0) {
      time.setHours(0);
      time.setMinutes(0);
      time.setSeconds(0);
      isTimeAvailable = false;
    } else {
      time.setHours(time.getHours() + hours);
      time.setMinutes(time.getMinutes() + minutes);
      time.setSeconds(time.getSeconds() + seconds);
      isTimeAvailable = true;
    }
  };

  const CalculateDifferenceBetweenCurrentTimeAndSessionTime = (
    currentDate,
    auctionEndDate,
    auctionDate
  ) => {
    let date1 = new Date(currentDate);
    let date2 = new Date(auctionDate);
    let date3 = new Date(auctionEndDate);

    // Calculate the time difference in milliseconds
    let timeDifferenceOfCurrentAndAuctionDate = 1;
    if (date1.getTime() > date2.getTime()) {
      timeDifferenceOfCurrentAndAuctionDate = date3 - date1;
    } else {
      timeDifferenceOfCurrentAndAuctionDate = date3 - date2;
    }

    // Convert the time difference to a more human-readable format
    let seconds = Math.floor(
      (timeDifferenceOfCurrentAndAuctionDate / 1000) % 60
    );

    let minutes = Math.floor(
      (timeDifferenceOfCurrentAndAuctionDate / (1000 * 60)) % 60
    );

    let hours = Math.floor(
      (timeDifferenceOfCurrentAndAuctionDate / (1000 * 60 * 60)) % 24
    );

    if (hours <= 0 && minutes <= 0 && seconds <= 0) {
      sessiontime.setHours(0);
      sessiontime.setMinutes(0);
      sessiontime.setSeconds(0);
      isTimeAvailable = false;
    } else {
      sessiontime.setHours(sessiontime.getHours() + hours);
      sessiontime.setMinutes(sessiontime.getMinutes() + minutes);
      sessiontime.setSeconds(sessiontime.getSeconds() + seconds);
      isTimeAvailable = true;
    }
  };
  function MyTimer({ expiryTimestamp }) {
    const { seconds, minutes, hours } = useTimer({
      expiryTimestamp,
      // onExpire: () => console.warn("onExpire called"),
    });
    return (
      <>
        <span>{hours > 9 ? hours : "0" + hours}</span>:
        <span>{minutes > 9 ? minutes : "0" + minutes}</span>:
        <span>{seconds > 9 ? seconds : "0" + seconds}</span>
      </>
    );
  }

  function MyTimer1({ remainingSeconds }) {
    const [timeLeft, setTimeLeft] = useState(remainingSeconds);

    useEffect(() => {
      if (timeLeft > 0) {
        const timer = setTimeout(() => {
          setTimeLeft(timeLeft - 1);
        }, 1000);

        return () => clearTimeout(timer);
      } else {
        remainingSeconds = 0;
      }
    }, [timeLeft]);

    // Convert remaining seconds to hours, minutes, and seconds
    const hours = Math.floor(timeLeft / 3600);
    const minutes = Math.floor((timeLeft % 3600) / 60);
    const seconds = timeLeft % 60;

    return (
      <>
        <span>{hours > 9 ? hours : "0" + hours}</span>:
        <span>{minutes > 9 ? minutes : "0" + minutes}</span>:
        <span>{seconds > 9 ? seconds : "0" + seconds}</span>
      </>
    );
  }

  const englishHauctionHeaderdata = useSelector(
    (state) => state?.englishAuctionReducer?.englishauctiondata?.responseData
  );
  const ViewTeaSold = useSelector(
    (state) => state?.EnglishVR?.viewTeaSold?.responseData
  );

  const getViewTeaSolddata = useSelector(
    (state) => state?.EnglishVR?.viewTeaSold
  );

  const ViewTeaSoldLot = useSelector(
    (state) => state?.EnglishVR?.viewTeaSoldLot?.responseData
  );

  const getViewTeaSoldLotData = useSelector(
    (state) => state?.EnglishVR?.viewTeaSoldLot
  );

  const ViewTeaSoldMarket = useSelector(
    (state) => state?.EnglishVR?.viewTeaSoldMarket?.responseData
  );
  const getViewTeaSoldMarketData = useSelector(
    (state) => state?.EnglishVR?.viewTeaSoldMarket
  );
  const ViewTeaauctioneer = useSelector(
    (state) => state?.EnglishVR?.viewTeaAuctioneer?.responseData
  );

  const getViewTeaauctioneerData = useSelector(
    (state) => state?.EnglishVR?.viewTeaAuctioneer
  );

  const viewMarketSummary = useSelector(
    (state) => state?.EnglishVR?.viewMarketSummary?.responseData
  );
  const getviewMarketData = useSelector(
    (state) => state?.EnglishVR?.viewMarketSummary
  );

  const myPlanner = useSelector(
    (state) => state?.EnglishVR?.myPlanner?.responseData
  );
  const getPlannerAll = useSelector((state) => state?.EnglishVR?.myPlanner);

  const loadingViewTeaSold = useSelector(
    (state) => state?.EnglishVR?.loadingTeaSoldLotMarket
  );
  const loadingViewMarketSummary = useSelector(
    (state) => state?.EnglishVR?.loadingMarketSummary
  );
  const loadingviewTeaAuctioneer = useSelector(
    (state) => state?.EnglishVR?.loadingAuctionneer
  );
  const loadingViewTeaLot = useSelector(
    (state) => state?.EnglishVR?.loadingViewTeaLot
  );
  const loadingViewTea = useSelector(
    (state) => state?.EnglishVR?.loadingViewTeaSold
  );

  const loadingPlanner = useSelector(
    (state) => state?.EnglishVR?.loadingPlanner
  );
  const loadingMarketDepth = useSelector(
    (state) => state?.EnglishVR?.loadingMarketDepth
  );

  const getCatalogAll = useSelector((state) => state?.EnglishVR?.Viewcatalog);

  const MarketDepthdata = useSelector(
    (state) => state?.EnglishVR?.mymarketdepth?.responseData
  );

  const getMarketDepthdata = useSelector(
    (state) => state?.EnglishVR?.mymarketdepth
  );

  

  const AddData = useSelector((state) => state?.EnglishVR?.Adddata);
  const RemoveData = useSelector((state) => state?.EnglishVR?.Removedata);
  const UserWiseData = useSelector((state) => state?.EnglishVR?.userWiseStutas);
  const DefaultData = useSelector((state) => state?.EnglishVR?.defaultStutas);
  const ValuationData = useSelector((state) => state?.EnglishVR?.valueStatus);

  useEffect(() => {
    if (true == ValuationData && loader) {
      setTimeout(() => {
        setLoader(false);
        setshowValuation(false);
        setFormData({
          commonUserId: userId,
          auctionDetailId: auctionDetailId,
          auctionItemDetailId: auctionitemId,
          myComments: "",
          myValuation: "",
        });
        setSelectedRowsRemove([]);
        setGroupCode([]);
        setMark([]);
        setLotNos([]);
        setGrade([]);
        setComments([]);
        setValuation([]);
        dispatch(
          actionUrl.MyCatalogViewIdAction({
            auctionDetailId: auctionDetailId,
            userLoginId: userId,
          })
        );
      }, 1000);
    }
  });
  useEffect(() => {
    if (true == DefaultData && loader) {
      setTimeout(() => {
        setLoader(false);
        dispatch(
          actionUrl.MyCatalogViewIdAction({
            auctionDetailId: auctionDetailId,
            userLoginId: userId,
          })
        );
      }, 1000);
    }
  });
  // useEffect(() => {
  //   if (true == UserWiseData && loader) {
  //     setTimeout(() => {
  //       setLoader(false);
  //       dispatch(
  //         actionUrl.MyCatalogViewIdAction({
  //           auctionDetailId: auctionDetailId,
  //           userLoginId: userId,
  //         })
  //       );
  //     }, 1000);
  //   }
  // });

  useEffect(() => {
    if (true == AddData && loader) {
      setTimeout(() => {
        setLoader(false);
        dispatch(
          actionUrl.MyCatalogViewIdAction({
            auctionDetailId: auctionDetailId,
            userLoginId: userId,
          })
        );
      }, 1000);
    }
  });
  const [isChecked, setIsChecked] = useState(false);
  const SelectAll = (event) => {
    let isChecked = event.target.checked;
    setIsChecked(event.target.checked);
    localConfigColumnDetails.map((data, index) =>
      data.isEditable == 1 ? (data.isShown = isChecked ? 1 : 0) : ""
    );
  };
  const SelectAllCatalog = (event) => {
    let isChecked = event.target.checked;
    setIsChecked(event.target.checked);
    CatalogConfigColumnDetails.map((data, index) =>
      data.isEditable == 1 ? (data.isShown = isChecked ? 1 : 0) : ""
    );
  };
  useEffect(() => {
    if (true == RemoveData && loader) {
      setTimeout(() => {
        setLoader(false);
        dispatch(
          actionUrl.MyCatalogViewIdAction({
            auctionDetailId: auctionDetailId,
            userLoginId: userId,
          })
        );
      }, 1000);
    }
  });

  const handleClose = () => setShow(false);
  const handleBidBookClose = () => {
    dispatch(actionUrl.fetchBidBookSuccess([]));
    dispatch(actionUrl.fetchBidBookSearchDropdownDataSuccess([]));
    setbidbookShow(false);
    setitemIdExport(null);
  };
  function dataofHeader() {
    return (
      <>
        <div className="container-fluid-">
          <div>
            <div className="header-Bharat">
              <MBTTime />
              <span className="divider"></span>
              <SessionRemaining />
              <span className="divider"></span>
              <YourComponent />
              <span className="divider"></span>
              <span>
                <b>Season :</b>
                {englishHauctionHeaderdata && englishHauctionHeaderdata.season}
              </span>
              <span className="divider"></span>
              <span>
                <b>Sale No :</b>
                {englishHauctionHeaderdata && englishHauctionHeaderdata.saleNo}
              </span>
              <span className="divider"></span>
              <span>
                <b>Auction Date :</b>
                {englishHauctionHeaderdata &&
                  englishHauctionHeaderdata.auctionDate}
              </span>

              <span className="divider"></span>
              <span>
                <b>Current Session Time :</b>
                {englishHauctionHeaderdata &&
                  englishHauctionHeaderdata.currentSessionTime}
              </span>
            </div>
          </div>
          <div className={"EnglishAuction"}>
            <div
              className={`TableBox ${
                isActiveStateCount == 1
                  ? "box1"
                  : isActiveStateCount == 2
                  ? "box2"
                  : isActiveStateCount == 3
                  ? "box3"
                  : "default"
              } `}
            >
              <div className="MainComponent">
                <div className="AuctionScreen">
                  <div className="TabsMenu">
                    <ul>
                      {rightsIdData &&
                      rightsIdData?.length &&
                      rightsIdData?.length > 0 &&
                      rightsIdData?.includes("43") ? (
                        <li
                          className={
                            showmyAuctioneer == true
                              ? "SubmitBtn active"
                              : "SubmitBtn"
                          }
                          onClick={() => handleMyAuctioneer(true)}
                        >
                          Auction Catalog
                        </li>
                      ) : (
                        ""
                      )}
                      {userRoleCode == "BUYER" ||
                      userRoleCode == "ASSOCIATEBUYER" ||
                      userRoleCode == "POSTAUCTIONASSOCIATEBUYER" ||
                      userRoleCode == "AUCTIONEER" ||
                      userRoleCode == "SELLER" ||
                      userRoleCode == "ASSOCIATEAUCTIONEER" ||
                      userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER" ? (
                        rightsIdData &&
                        rightsIdData?.length &&
                        rightsIdData?.length > 0 &&
                        rightsIdData?.includes("82") ? (
                          <li
                            className={
                              showmyCatalog == true
                                ? "SubmitBtn active"
                                : "SubmitBtn"
                            }
                            onClick={() => handleMyCatalog()}
                          >
                            My Catalog
                          </li>
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}
                      {userRoleCode == "BUYER" ||
                      userRoleCode == "ASSOCIATEBUYER" ||
                      userRoleCode == "POSTAUCTIONASSOCIATEBUYER" ? (
                        rightsIdData &&
                        rightsIdData?.length &&
                        rightsIdData?.length > 0 &&
                        rightsIdData?.includes("45") ? (
                          <li
                            className={
                              showmyplanner == true
                                ? "SubmitBtn active"
                                : "SubmitBtn"
                            }
                            onClick={() => handleMyPlanner()}
                          >
                            My Planner
                          </li>
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}
                      {rightsIdData?.length > 0 &&
                      rightsIdData?.includes("44") ? (
                        <li
                          className={
                            showSideSlide == true
                              ? "SubmitBtn active"
                              : "SubmitBtn"
                          }
                          onClick={() => handleShowSideSlide()}
                        >
                          Summary
                        </li>
                      ) : (
                        ""
                      )}
                    </ul>
                    {showmyAuctioneer && (
                      <>
                        <div className="TabsMenu">
                          <div>
                            {rightsIdData &&
                            rightsIdData?.length &&
                            rightsIdData?.length > 0 &&
                            rightsIdData?.includes("46") ? (
                              <Button
                                className="SubmitBtn RemoveCatalog"
                                onClick={() => handleDefaultButtonLiveAuction()}
                              >
                                Restore Defaults
                              </Button>
                            ) : (
                              ""
                            )}
                          </div>
                          {userRoleCode == "TAOUSER" ||
                          userRoleCode == "BUYER" ||
                          userRoleCode == "ASSOCIATEBUYER" ||
                          userRoleCode == "POSTAUCTIONASSOCIATEBUYER" ||
                          userRoleCode == "AUCTIONEER" ||
                          userRoleCode == "ASSOCIATEAUCTIONEER" ||
                          userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER" ||
                          userRoleCode == "TEABOARDUSER" ||
                          userRoleCode == "WAREHOUSEUNIT" ||
                          userRoleCode == "WAREHOUSE" ||
                          userRoleCode == "SELLER" ? (
                            rightsIdData &&
                            rightsIdData?.length &&
                            rightsIdData?.length > 0 &&
                            rightsIdData?.includes("83") ? (
                              <>
                                <div>
                                  <Button
                                    className="SubmitBtn"
                                    onClick={() =>
                                      handleAddRemoveButtonViewBidBook(
                                        "AddMyCatalogAction",
                                        ""
                                      )
                                    }
                                  >
                                    View Bid Book
                                  </Button>
                                </div>
                              </>
                            ) : (
                              ""
                            )
                          ) : (
                            ""
                          )}
                          {userRoleCode == "BUYER" ||
                          userRoleCode == "ASSOCIATEBUYER" ||
                          userRoleCode == "POSTAUCTIONASSOCIATEBUYER" ||
                          userRoleCode == "AUCTIONEER" ||
                          userRoleCode == "SELLER" ||
                          userRoleCode == "ASSOCIATEAUCTIONEER" ||
                          userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER" ? (
                            rightsIdData &&
                            rightsIdData?.length &&
                            rightsIdData?.length > 0 &&
                            rightsIdData?.includes("82") ? (
                              <>
                                <div>
                                  <Button
                                    className="SubmitBtn"
                                    onClick={() =>
                                      handleAddRemoveButton(
                                        "AddMyCatalogAction",
                                        ""
                                      )
                                    }
                                  >
                                    Add To My Catalog
                                  </Button>
                                </div>
                              </>
                            ) : (
                              ""
                            )
                          ) : (
                            ""
                          )}
                          {rightsIdData &&
                          rightsIdData?.length &&
                          rightsIdData?.length > 0 &&
                          rightsIdData?.includes("46") ? (
                            <a
                              className="TableSetting"
                              onClick={() => {
                                setShow(true);
                                dispatch(
                                  actionUrl.fetchDefaultColumnConfigRequest({
                                    auctionDetailId: auctionDetailId,
                                    userId: userId,
                                  })
                                );
                              }}
                            >
                              <i
                                className="fa fa-wrench"
                                aria-hidden="true"
                              ></i>
                            </a>
                          ) : (
                            ""
                          )}
                        </div>
                      </>
                    )}

                    {showmyCatalog && (
                      <>
                        <div>
                          {(userRoleCode == "AUCTIONEER" ||
                            userRoleCode == "ASSOCIATEAUCTIONEER" ||
                            userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER") &&
                            (rightsIdData &&
                            rightsIdData?.length &&
                            rightsIdData?.length > 0 &&
                            rightsIdData?.includes("85") ? (
                              <>
                                <Button
                                  className="SubmitBtn RemoveCatalog"
                                  onClick={() => handleChangePriceButton()}
                                >
                                  Change Reserve Price
                                </Button>
                              </>
                            ) : (
                              ""
                            ))}
                          {(userRoleCode == "BUYER" ||
                            userRoleCode == "ASSOCIATEBUYER" ||
                            userRoleCode == "POSTAUCTIONASSOCIATEBUYER") &&
                            (rightsIdData &&
                            rightsIdData?.length &&
                            rightsIdData?.length > 0 &&
                            rightsIdData?.includes("86") ? (
                              <>
                                <Button
                                  className="SubmitBtn RemoveCatalog"
                                  onClick={() => handleValuationButton()}
                                  disabled={
                                    userWiseViewEnglishAuctionData?.userStatus ==
                                    2
                                      ? true
                                      : false
                                  }
                                >
                                  Valuation
                                </Button>
                              </>
                            ) : (
                              ""
                            ))}
                          {rightsIdData &&
                          rightsIdData?.length &&
                          rightsIdData?.length > 0 &&
                          rightsIdData?.includes("46") ? (
                            <Button
                              className="SubmitBtn RemoveCatalog"
                              onClick={() => handleDefaultButton()}
                            >
                              Restore Defaults
                            </Button>
                          ) : (
                            ""
                          )}
                          <Button
                            className="SubmitBtn RemoveCatalog"
                            onClick={() =>
                              handleAddRemoveButton("RemoveMyCatalogAction", "")
                            }
                          >
                            Remove Catalog
                          </Button>
                          {rightsIdData &&
                          rightsIdData?.length &&
                          rightsIdData?.length > 0 &&
                          rightsIdData?.includes("46") ? (
                            <a
                              className="TableSetting"
                              onClick={() => {
                                setshowColumn(true);
                                dispatch(
                                  actionUrl.UserwiseCloumnConfigAction({
                                    auctionDetailId: auctionDetailId,
                                    userLoginId: userId,
                                  })
                                );
                              }}
                            >
                              <i
                                className="fa fa-wrench"
                                aria-hidden="true"
                              ></i>
                            </a>
                          ) : (
                            ""
                          )}
                        </div>
                      </>
                    )}
                  </div>
                  {showmyAuctioneer && !showmyCatalog ? (
                    <div className="LiveAuction">
                      <div
                        className={`TableBox- ${
                          showmyCatalog == true ? "active" : ""
                        }`}
                      >
                        {userWiseViewEnglishAuctionData != undefined ? (
                          <EnglishTable
                            userWiseViewEnglishAuctionData={
                              userWiseViewEnglishAuctionData
                            }
                            handleChange={handleChange}
                            handleButton={handleButton}
                            fixedColumns={fixedColumns}
                            handleSelectRow={handleSelectRow}
                            handleMarketDepth={handleMarketDepth}
                            selectedRows={selectedRows}
                            handleAddRemoveButton={handleAddRemoveButton}
                            selectedDataForMyCatalog={selectedDataForMyCatalog}
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  ) : showmyCatalog ? (
                    <div className="LiveAuction">
                      <div
                        className={`TableBox- ${
                          showmyCatalog == true ? "active" : ""
                        }`}
                      >
                        {200 != getCatalogAll?.statusCode ? (
                          <div className="NoData">No Records Found</div>
                        ) : (
                          <CatalogTable
                            userWiseViewEnglishAuctionData={
                              userWiseViewEnglishAuctionData
                            }
                            setuserWiseViewEnglishAuctionData={
                              setuserWiseViewEnglishAuctionData
                            }
                            setAuctionItemDetails={setAuctionItemDetails}
                            auctionItemDetails={auctionItemDetails}
                            auctionItemRowId={auctionItemRowId}
                            setshowListMsg={setshowListMsg}
                            selectedRowsRemove={selectedRowsRemove}
                            handleSelectRowRemove={handleSelectRowRemove}
                            handleChangeCatalog={handleChangeCatalog}
                            handleButtonCatalog={handleButtonCatalog}
                            handleButtonChangePrice={handleButtonChangePrice}
                            myCatalogViewdata={myCatalogViewdata}
                            setMyCatalogViewData={setMyCatalogViewData}
                          />
                        )}
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
            <NotificationMsg/>
          </div>
        </div>
      </>
    );
  }
  const handleCloseColumn = () => setshowColumn(false);

  const isActiveStateCount = [
    showSideSlide,
    showmyplanner,
    showMarketDepth,
  ].filter((state) => state).length;

  return (
    <>
      {userWiseViewEnglishAuctionData == undefined ||
      userWiseViewEnglishAuctionData.liveBidDetails == null ||
      (0 == userWiseViewEnglishAuctionData.liveBidDetails &&
        userWiseViewEnglishAuctionData.liveBidDetails.length) ? (
        "No data found"
      ) : (
        <div>
          <Modal show={show} onHide={handleClose}>
            <Modal.Header>
              <Modal.Title>Table Setting</Modal.Title>
              <i className="fa fa-times CloseModal" onClick={handleClose}></i>
            </Modal.Header>

            <Modal.Body>
              <div className="row">
                {/* <div className="col-md-6">
              <div className="FomrGroup">
                <label>Left Column</label>
                <input
                  type="text"
                  className="form-control"
                  min={0}
                  max={5}
                  value={stickyInput.leftNo >= 0 ? stickyInput.leftNo : ""}
                  onChange={(e) =>
                    setStickyInput({
                      ...stickyInput,
                      leftNo:
                        e.target.value <= 5 ? parseFloat(e.target.value) : "",
                    })
                  }
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="FomrGroup">
                <label>Right Column</label>
                <input
                  type="text"
                  className="form-control"
                  value={stickyInput.rightNo >= 0 ? stickyInput.rightNo : ""}
                  min={0}
                  max={columns.length}
                  onChange={(e) =>
                    setStickyInput({
                      ...stickyInput,
                      rightNo:
                        e.target.value <= 5 ? parseFloat(e.target.value) : "",
                    })
                  }
                />
              </div>
            </div> */}
                <div class="col-md-12">
                  <div class="CardBox">
                    <h5 class="SmallTitle">Select Column</h5>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="selectAll"
                        checked={isChecked}
                        onChange={(event) => {
                          SelectAll(event);
                        }}
                      />
                      <label className="ml-2" htmlFor="selectAll">
                        <b>Select/Deselect All</b>
                      </label>
                    </div>
                    <ul>
                      {localConfigColumnDetails &&
                        localConfigColumnDetails.map((data, index) => (
                          <li>
                            <div class="form-check">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                name="isShown"
                                value={data.isShown}
                                id={data.columnTypeId}
                                checked={data.isShown == 1 ? true : false}
                                onChange={(event) => {
                                  selectRecord(
                                    event.target.name,
                                    event.target.checked == true ? 1 : 0,
                                    data.columnTypeId
                                  );
                                }}
                                disabled={data.isEditable == 0 ? true : false}
                              />
                              <label className="ml-2">{data.columnName}</label>
                            </div>
                          </li>
                        ))}
                    </ul>
                  </div>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="SubmitBtn"
                onClick={() => handleStickySubmit()}
              >
                Apply
              </Button>
            </Modal.Footer>
          </Modal>
          {
            //Bid book Modal start
          }
          <Modal show={bidbookshow} onHide={handleBidBookClose} size="xl">
            <Modal.Header>
              <Modal.Title>Bid Book</Modal.Title>
              <i
                className="fa fa-times CloseModal"
                onClick={handleBidBookClose}
              ></i>
            </Modal.Header>

            <Modal.Body>
              {loaderBidBook ? (
                <>
                  <div className="">
                    <ThreeDots
                      visible={true}
                      height="80"
                      width="80"
                      color="#4fa94d"
                      radius="9"
                      ariaLabel="three-dots-loading"
                      wrapperStyle={{}}
                      wrapperClass=""
                    />
                  </div>
                </>
              ) : (
                <>
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="row align-items-end">
                        {userRoleCode == "TAOUSER" ||
                        userRoleCode == "TEABOARDUSER" ? (
                          <>
                            <div className="col-md-4">
                              <div className="FormGroup">
                                <label>Lot No</label>
                                <select
                                  className="form-control select-form"
                                  value={searchlotNo}
                                  onChange={(e) =>
                                    setsearchlotNo(e.target.value)
                                  }
                                  disabled
                                >
                                  {lotDropdownData?.map((state) => (
                                    <option
                                      key={state.lotNo}
                                      value={state.lotNo}
                                    >
                                      {state.lotNo}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="FormGroup">
                                <label>Grade Name</label>
                                <select
                                  className="form-control select-form"
                                  value={searchGradeCode}
                                  onChange={(e) =>
                                    setSearchGradeCode(e.target.value)
                                  }
                                  disabled
                                >
                                  {gradeDropdownData?.map((state) => (
                                    <option
                                      key={state.gradeId}
                                      value={state.gradeId}
                                    >
                                      {state.grade}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="FormGroup">
                                <label>Mark Name</label>
                                <select
                                  className="form-control select-form"
                                  value={markCode}
                                  onChange={(e) => setmarkCode(e.target.value)}
                                  disabled
                                >
                                  {markDropdownData?.map((state) => (
                                    <option
                                      key={state.markId}
                                      value={state.markId}
                                    >
                                      {state.mark}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </>
                        ) : userRoleCode == "BUYER" ||
                          userRoleCode == "ASSOCIATEBUYER" ||
                          userRoleCode == "POSTAUCTIONASSOCIATEBUYER" ? (
                          <>
                            <div className="col-md-4">
                              <div className="FormGroup">
                                <label>Grade Name</label>
                                <select
                                  className="form-control select-form"
                                  value={searchGradeCode}
                                  onChange={(e) =>
                                    setSearchGradeCode(e.target.value)
                                  }
                                >
                                  <option value="">ALL</option>
                                  {gradeDropdownData?.map((state) => (
                                    <option
                                      key={state.gradeId}
                                      value={state.gradeId}
                                    >
                                      {state.grade}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="FormGroup">
                                <label>Mark Name</label>
                                <select
                                  className="form-control select-form"
                                  value={markCode}
                                  onChange={(e) => setmarkCode(e.target.value)}
                                >
                                  <option value={0}>ALL</option>

                                  {markDropdownData?.map((state) => (
                                    <option
                                      key={state.markId}
                                      value={state.markId}
                                    >
                                      {state.mark}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </>
                        ) : userRoleCode == "AUCTIONEER" ||
                          userRoleCode == "ASSOCIATEAUCTIONEER" ||
                          userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER" ||
                          userRoleCode == "SELLER" ||
                          userRoleCode == "WAREHOUSEUNIT" ||
                          userRoleCode == "WAREHOUSE" ? (
                          <>
                            <div className="col-md-4">
                              <div className="FormGroup">
                                <label>Lot No</label>
                                <select
                                  className="form-control select-form"
                                  value={searchlotNo}
                                  onChange={(e) =>
                                    setsearchlotNo(e.target.value)
                                  }
                                >
                                  <option value="">ALL</option>
                                  {lotDropdownData?.map((state) => (
                                    <option
                                      key={state.lotNo}
                                      value={state.lotNo}
                                    >
                                      {state.lotNo}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="FormGroup">
                                <label>Lot Status</label>
                                <select
                                  className="form-control select-form"
                                  value={searchlotStatus}
                                  onChange={(e) =>
                                    setsearchlotStatus(e.target.value)
                                  }
                                >
                                  <option value="">All</option>
                                  <option value="2">Sold</option>
                                  <option value="3">Unsold</option>
                                  <option value="0">Pending</option>
                                </select>
                              </div>
                            </div>
                          </>
                        ) : (
                          ""
                        )}
                        {userRoleCode != "TAOUSER" &&
                        userRoleCode != "TEABOARDUSER" ? (
                          <>
                            <div className="col-md-12">
                              <div className="BtnGroup">
                                <button
                                  className="SubmitBtn"
                                  onClick={handleSubmitBidBook}
                                >
                                  Search
                                </button>
                                <button className="Clear" onClick={resetForm}>
                                  Clear
                                </button>
                              </div>
                            </div>
                          </>
                        ) : (
                          ""
                        )}
                      </div>
                      <div class="table-responsive">
                        <table
                          id="example"
                          class="stripe- row-border order-column table "
                        >
                          <thead>
                            <tr>
                              {userRoleCode == "TAOUSER" ||
                              userRoleCode == "TEABOARDUSER" ? (
                                <>
                                  <th>Lot No.</th>
                                  <th>Mark</th>
                                  <th>Grade</th>
                                  <th>Inv. No.</th>
                                  <th>Server Bid No.</th>
                                  <th>Bid Price</th>
                                  <th>Bid Date & Time</th>
                                  <th>Bid Qty.</th>
                                  <th>Share Qty.</th>
                                  <th>Buy Qty. @ HBP</th>
                                  <th>Status</th>
                                </>
                              ) : userRoleCode == "BUYER" ||
                                userRoleCode == "ASSOCIATEBUYER" ||
                                userRoleCode == "POSTAUCTIONASSOCIATEBUYER" ? (
                                <>
                                  <th>Lot No.</th>
                                  <th>Origin</th>
                                  <th>Mark</th>
                                  <th>Grade</th>
                                  <th>Buy Qty.</th>
                                  <th>Share Qty.</th>
                                  <th>Buy Qty. @ HBP</th>
                                  <th>Bid Price</th>
                                  <th>Auto Bid Limit</th>
                                  <th>Limit Price</th>
                                  <th>MAQ@HBP</th>
                                  <th>Server Bid No.</th>
                                  <th>Status</th>
                                  <th>Bid Date & Time</th>
                                </>
                              ) : userRoleCode == "AUCTIONEER" ||
                                userRoleCode == "ASSOCIATEAUCTIONEER" ||
                                userRoleCode ==
                                  "POSTAUCTIONASSOCIATEAUCTIONEER" ||
                                userRoleCode == "WAREHOUSEUNIT" ||
                                userRoleCode == "WAREHOUSE" ||
                                userRoleCode == "SELLER" ? (
                                <>
                                  <th>Invoice No.</th>
                                  <th>Lot No.</th>
                                  <th>Grade</th>
                                  <th>Mark</th>
                                  <th>Buy Share</th>
                                  <th>Share Qty.</th>
                                  <th>Bid Price</th>
                                  <th>Buy Share @ HBP</th>
                                  <th>Bid Date & Time</th>
                                  <th>Bid Status</th>
                                  <th>Lot Status</th>
                                </>
                              ) : (
                                ""
                              )}
                            </tr>
                          </thead>
                          {bidBookData &&
                            bidBookData.map((col, index) => (
                              <tr>
                                {userRoleCode == "BUYER" ||
                                userRoleCode == "ASSOCIATEBUYER" ||
                                userRoleCode == "POSTAUCTIONASSOCIATEBUYER" ? (
                                  <>
                                    <td> {col.lotNo}</td>
                                    <td> {col.origin}</td>
                                    <td> {col.mark}</td>
                                    <td> {col.grade}</td>
                                    <td> {col.buyQty}</td>
                                    <td> {col.shareQty}</td>
                                    <td> {col.buyQtyHBP}</td>
                                    <td> {col.bidPrice}</td>
                                    <td> {col.autoBidlimit}</td>
                                    <td> {col.limitPrice}</td>
                                    <td> {col.minimumNoOfPackage}</td>
                                    <td> {col.serverBidNo}</td>
                                    <td> {col.status}</td>
                                    <td> {col.bidDateTime}</td>
                                  </>
                                ) : userRoleCode == "AUCTIONEER" ||
                                  userRoleCode == "ASSOCIATEAUCTIONEER" ||
                                  userRoleCode ==
                                    "POSTAUCTIONASSOCIATEAUCTIONEER" ||
                                  userRoleCode == "WAREHOUSEUNIT" ||
                                  userRoleCode == "WAREHOUSE" ||
                                  userRoleCode == "SELLER" ? (
                                  <>
                                    <td> {col.invoiceNo}</td>
                                    <td> {col.lotNo}</td>
                                    <td> {col.grade}</td>
                                    <td> {col.mark}</td>
                                    <td> {col.buyQty}</td>
                                    <td> {col.shareQty}</td>
                                    <td> {col.bidPrice}</td>
                                    <td> {col.buyQtyHBP}</td>
                                    <td> {col.bidDateTime}</td>
                                    <td> {col.bidstatus}</td>
                                    <td> {col.lotStatus}</td>
                                  </>
                                ) : userRoleCode == "TAOUSER" ||
                                  userRoleCode == "TEABOARDUSER" ? (
                                  <>
                                    <td> {col.lotNo}</td>
                                    <td> {col.mark}</td>
                                    <td> {col.grade}</td>
                                    <td> {col.invoiceNo}</td>
                                    <td> {col.serverBidNo}</td>
                                    <td> {col.bidPrice}</td>
                                    <td> {col.bidDateTime}</td>
                                    <td> {col.buyQty}</td>
                                    <td> {col.shareQty}</td>
                                    <td> {col.buyQtyHBP}</td>
                                    <td>{col.bidstatus}</td>
                                  </>
                                ) : (
                                  ""
                                )}
                              </tr>
                            ))}
                        </table>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="BtnGroup">
                        <button
                          class="SubmitBtn"
                          onClick={() => handleExport("pdf")}
                        >
                          <i class="fa fa-file-pdf"></i>
                        </button>
                        <button
                          class="SubmitBtn"
                          onClick={() => handleExport("excel")}
                        >
                          <i class="fa fa-file-excel"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </Modal.Body>
          </Modal>
          {
            //Bid book Modal end
          }
          {dataofHeader()}

          {/* {showmodal && ( */}
          {isActiveStateCount > 0 && (
            <div className="LiveAuctionMenu ft-box">
              {showSideSlide && (
                <div className="LiveAuctionMenu active  false">
                  <div className="row">
                    <div className="col-12"></div>
                  </div>
                  <div className="Summery">
                    <span class="Close" onClick={handleCloseSideSlide}>
                      x
                    </span>

                    <div className="row mt-3">
                      <div className="col-4">
                        <div className="Title">
                          {!showMainTable && (
                            <a href="javascript:void(0)">
                              <i
                                className="fa fa-angle-left"
                                onClick={handleBackClick}
                              ></i>
                            </a>
                          )}
                          &nbsp;Summary of Tea Sold
                        </div>
                        {showMainTable && (
                          <div className="Shadow">
                            <div className="TableBox">
                              <Table striped bordered hover>
                                <thead>
                                  <tr>
                                    <th scope="col">Lot No</th>
                                    <th scope="col">Mark</th>
                                    <th scope="col">Grade</th>
                                    <th scope="col">Pkgs</th>
                                    <th scope="col">HBP</th>
                                    <th scope="col">HBidder</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {loadingViewTea ? (
                                    <div className="">
                                      <ThreeDots
                                        visible={true}
                                        height="80"
                                        width="80"
                                        color="#4fa94d"
                                        radius="9"
                                        ariaLabel="three-dots-loading"
                                        wrapperStyle={{}}
                                        wrapperClass=""
                                      />
                                    </div>
                                  ) : 204 === getViewTeaSolddata.statusCode ? (
                                    <td colSpan={6}>
                                      <div className="NoData">
                                        No Records Found
                                      </div>
                                    </td>
                                  ) : ViewTeaSold?.length > 0 ? (
                                    <>
                                      {ViewTeaSold?.map((item, index) => (
                                        <tr key={index}>
                                          <td>
                                            <a
                                              href="#"
                                              onClick={() =>
                                                handleLotClick(
                                                  item.auctionItemDetailId
                                                )
                                              }
                                            >
                                              {item.lotNo}
                                            </a>
                                          </td>
                                          <td>{item.mark}</td>
                                          <td>{item.grade}</td>
                                          <td>{item.noOfPackages}</td>
                                          <td>{item.hbp}</td>
                                          <td>{item.h1Buyer}</td>
                                        </tr>
                                      ))}
                                    </>
                                  ) : null}
                                </tbody>
                              </Table>
                            </div>
                          </div>
                        )}

                        {SelectedAuctionItem && !showMainTable && (
                          <div className="row mt-6">
                            <div className="col-12">
                              <table
                                aria-labelledby="tableTitle1"
                                className="table"
                              >
                                <tbody>
                                  <tr>
                                    <th> LotNo</th>{" "}
                                    <td> {ViewTeaSoldLot?.lotNo} </td>
                                    <th> Mark</th>{" "}
                                    <td> {ViewTeaSoldLot?.mark} </td>
                                    <th> Grade</th>{" "}
                                    <td> {ViewTeaSoldLot?.grade} </td>
                                  </tr>
                                </tbody>
                              </table>
                              <div className="TableBox">
                                <Table striped bordered hover>
                                  <thead>
                                    <tr>
                                      <th scope="col">Buyer Name</th>
                                      <th scope="col">Deal Price</th>
                                      <th scope="col">No.Of Pkgs</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {loadingViewTeaLot ? (
                                      <div className="">
                                        <ThreeDots
                                          visible={true}
                                          height="80"
                                          width="80"
                                          color="#4fa94d"
                                          radius="9"
                                          ariaLabel="three-dots-loading"
                                          wrapperStyle={{}}
                                          wrapperClass=""
                                        />
                                      </div>
                                    ) : 204 ===
                                      getViewTeaSoldLotData.statusCode ? (
                                      <td colSpan={3}>
                                        <div className="NoData">
                                          No Records Found
                                        </div>
                                      </td>
                                    ) : ViewTeaSoldLot?.hbiddersList?.length >
                                      0 ? (
                                      <>
                                        {ViewTeaSoldLot?.hbiddersList?.map(
                                          (item, index) => (
                                            <tr key={index}>
                                              <td>{item.buyerName}</td>
                                              <td>{item.dealPrice}</td>
                                              <td>{item.noOfPackages}</td>
                                            </tr>
                                          )
                                        )}
                                      </>
                                    ) : null}
                                  </tbody>
                                </Table>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="col-4">
                        <div className="Title">
                          {!showTable && (
                            <a href="javascript:void(0)">
                              <i
                                className="fa fa-angle-left"
                                onClick={handleBackeClick}
                              ></i>
                            </a>
                          )}{" "}
                          &nbsp; Auctioneer Market Summary
                        </div>
                        {showTable && (
                          <div className="Shadow">
                            <div className="TableBox">
                              <Table striped bordered hover className="table">
                                <thead>
                                  <tr>
                                    <th scope="col">Auctioneer Name</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {loadingviewTeaAuctioneer ? (
                                    <div className="">
                                      <ThreeDots
                                        visible={true}
                                        height="80"
                                        width="80"
                                        color="#4fa94d"
                                        radius="9"
                                        ariaLabel="three-dots-loading"
                                        wrapperStyle={{}}
                                        wrapperClass=""
                                      />
                                    </div>
                                  ) : 204 ===
                                    getViewTeaauctioneerData.statusCode ? (
                                    <td colSpan={1}>
                                      <div className="NoData">
                                        No Records Found
                                      </div>
                                    </td>
                                  ) : ViewTeaauctioneer &&
                                    ViewTeaauctioneer.length > 0 ? (
                                    <>
                                      {ViewTeaauctioneer.map((item, index) => (
                                        <tr key={index}>
                                          <td>
                                            <a
                                              href="#"
                                              onClick={() =>
                                                handleAuctioneerClick(
                                                  item.commonUserId,
                                                  item.auctioneerCode
                                                )
                                              }
                                            >
                                              {item.auctioneerCode}
                                            </a>
                                          </td>
                                        </tr>
                                      ))}
                                    </>
                                  ) : null}
                                </tbody>
                              </Table>
                            </div>
                          </div>
                        )}

                        {commonUserId && !showTable && (
                          <div className="col-15">
                            <table className="table">
                              <tbody>
                                <tr>
                                  <th colSpan="6">{selectedAuctioneer}</th>
                                </tr>
                              </tbody>
                            </table>
                            <div className="TableBox">
                              <table className="table">
                                <thead>
                                  <tr>
                                    <th scope="col"></th>
                                    <th scope="col">No Of Lots</th>
                                    <th scope="col">Pkgs</th>
                                    <th scope="col">Kgs</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {loadingViewTeaSold ? (
                                    <div className="">
                                      <ThreeDots
                                        visible={true}
                                        height="80"
                                        width="80"
                                        color="#4fa94d"
                                        radius="9"
                                        ariaLabel="three-dots-loading"
                                        wrapperStyle={{}}
                                        wrapperClass=""
                                      />
                                    </div>
                                  ) : 204 ===
                                    getViewTeaSoldMarketData?.statusCode ? (
                                    <td colSpan={4}>
                                      <div className="NoData">
                                        No Records Found
                                      </div>
                                    </td>
                                  ) : ViewTeaSoldMarket?.length > 0 ? (
                                    <>
                                      {ViewTeaSoldMarket?.map((item, index) => (
                                        <tr key={index}>
                                          <td>{item.columnName}</td>
                                          {ViewTeaSoldMarket.length - 1 ===
                                          index ? (
                                            <td colSpan="3">
                                              {item.averagePrice}
                                            </td>
                                          ) : (
                                            <>
                                              <td>{item.noOfLots}</td>
                                              <td>{item.noOfPackages}</td>
                                              <td>{item.totalKgs}</td>
                                            </>
                                          )}
                                        </tr>
                                      ))}
                                    </>
                                  ) : null}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="col-4">
                        <div className="Title">Market Summary</div>
                        <div className="TableBox">
                          <table className="table">
                            <thead>
                              <tr>
                                <th scope="col"></th>
                                <th scope="col">No Of Lots</th>
                                <th scope="col">Pkgs</th>
                                <th scope="col">Kgs</th>
                              </tr>
                            </thead>
                            <tbody>
                              {loadingViewMarketSummary ? (
                                <div className="">
                                  <ThreeDots
                                    visible={true}
                                    height="80"
                                    width="80"
                                    color="#4fa94d"
                                    radius="9"
                                    ariaLabel="three-dots-loading"
                                    wrapperStyle={{}}
                                    wrapperClass=""
                                  />
                                </div>
                              ) : 204 === getviewMarketData.statusCode ? (
                                <td colSpan={4}>
                                  <div className="NoData">No Records Found</div>
                                </td>
                              ) : viewMarketSummary?.length > 0 ? (
                                <>
                                  {viewMarketSummary.map((item, index) => (
                                    <tr key={index}>
                                      <td>{item.columnName}</td>
                                      {viewMarketSummary.length - 1 ===
                                      index ? (
                                        <td colSpan="3">
                                          {item.successfulBiddersCount}
                                        </td>
                                      ) : viewMarketSummary.length - 2 ===
                                        index ? (
                                        <td colSpan="3">{item.averagePrice}</td>
                                      ) : (
                                        <>
                                          <td>{item.noOfLots}</td>
                                          <td>{item.noOfPackages}</td>
                                          <td>{item.totalKgs}</td>
                                        </>
                                      )}
                                    </tr>
                                  ))}
                                </>
                              ) : null}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {showmyplanner && (
                <div className="LiveAuctionMenu active  false">
                  <div className="Summery">
                    <span class="Close" onClick={handleClosemyplanner}>
                      x
                    </span>

                    <div className="row mt-3">
                      <div className="col-12">
                        <div className="d-flex">
                          <div className="Title col-md-1">My Planner</div>
                          <div className="col-md-12">
                            <div className="BtnGroup">
                              <button
                                class="SubmitBtn"
                                onClick={() => handleMyplannerExport("pdf")}
                              >
                                <i class="fa fa-file-pdf"></i>
                              </button>
                              <button
                                class="SubmitBtn"
                                onClick={() => handleMyplannerExport("excel")}
                              >
                                <i class="fa fa-file-excel"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="TableBox">
                          <table aria-labelledby="tableTitle2">
                            <thead>
                              <tr>
                                <th scope="col">Group Code</th>
                                <th scope="col">Planned Qty. (PKgs)</th>
                                <th scope="col">Planner Qty. (KGs)</th>
                                <th scope="col">Average Price</th>
                                <th scope="col">Planned Amount (Rs.)</th>
                                <th scope="col">Balance Qty. (Pkgs)</th>
                                <th scope="col">Balance Qty. (KGs)</th>
                                <th scope="col">Balance Amount (Rs.)</th>
                                <th scope="col">Knockdown Qty. (Pkgs)</th>
                                <th scope="col">Knockdown Qty. (KGs)</th>
                                <th scope="col">Knockdown Avg. Price</th>
                                <th scope="col">Knockdown Amount (Rs)</th>
                                <th scope="col">Total</th>
                              </tr>
                            </thead>
                            <tbody>
                              {loadingPlanner ? (
                                <div className="">
                                  <ThreeDots
                                    visible={true}
                                    height="80"
                                    width="80"
                                    color="#4fa94d"
                                    radius="9"
                                    ariaLabel="three-dots-loading"
                                    wrapperStyle={{}}
                                    wrapperClass=""
                                  />
                                </div>
                              ) : 204 == getPlannerAll?.statusCode ? (
                                <td colSpan={13}>
                                  <div className="NoData">No Records Found</div>
                                </td>
                              ) : (
                                myPlanner?.length > 0 && (
                                  <>
                                    {myPlanner?.map((item, index) => (
                                      <tr key={index}>
                                        <td
                                          className={
                                            item.plannedKgs >=
                                            item.purchaseIndicator
                                              ? "highlight-cell1"
                                              : ""
                                          }
                                        >
                                          {item.groupCode}
                                        </td>
                                        <td>{item.plannedPackages}</td>
                                        <td>{item.plannedKgs}</td>
                                        <td>{item.averagePrice}</td>
                                        <td>{item.plannedAmount}</td>
                                        <td>{item.balancePackages}</td>
                                        <td>{item.balanceKgs}</td>
                                        <td>{item.balanceAmount}</td>
                                        <td>{item.knockDownPackages}</td>
                                        <td>{item.knockDownKgs}</td>
                                        <td>{item.knockDownAverageprice}</td>
                                        <td>{item.knockDownAmount}</td>
                                        <td>{item.totalOfAllColumns}</td>
                                      </tr>
                                    ))}
                                  </>
                                )
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {showMarketDepth && (
                <div className="LiveAuctionMenu active  false">
                  <div className="Summery">
                    <span class="Close" onClick={handleCloseMarketDepth}>
                      x
                    </span>

                    <div className="row mt-3">
                      <div className="col-12">
                        <div className="Title">Market Depth</div>
                        <table aria-labelledby="tableTitle1" className="table">
                          <tbody>
                            <tr>
                              <th>Lot No.</th>{" "}
                              <td> {MarketDepthdata?.lotNo} </td>
                              <th>Mark</th> <td> {MarketDepthdata?.mark} </td>
                              <th>Grade</th> <td> {MarketDepthdata?.grade} </td>
                            </tr>
                          </tbody>
                        </table>
                        <div className="TableBox">
                          <table
                            aria-labelledby="tableTitle2"
                            className="table"
                          >
                            <thead>
                              <tr>
                                <th>"*"</th>
                                <th>Share Qty.</th>
                                <th>Bid Price</th>
                                <th>Buy Qty.@ HBP</th>
                                <th>Bidder Name</th>
                              </tr>
                            </thead>
                            <tbody>
                              {loadingMarketDepth ? (
                                <div className="">
                                  <ThreeDots
                                    visible={true}
                                    height="80"
                                    width="80"
                                    color="#4fa94d"
                                    radius="9"
                                    ariaLabel="three-dots-loading"
                                    wrapperStyle={{}}
                                    wrapperClass=""
                                  />
                                </div>
                              ) : 204 === getMarketDepthdata.statusCode ? (
                                <div className="NoData">No Records Found</div>
                              ) : MarketDepthdata?.buyersBidLists?.length >
                                0 ? (
                                <>
                                  {MarketDepthdata?.buyersBidLists?.map(
                                    (data, index) => (
                                      <tr key={index}>
                                        <td>{data.star}</td>
                                        <td>{data.shareQty}</td>
                                        <td>{data.bidPrice}</td>
                                        <td>{data.buyQtyHBP}</td>
                                        <td>{data.userName}</td>
                                      </tr>
                                    )
                                  )}
                                </>
                              ) : null}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}

          {ChangePriceModel && (
            <Modal
              show={ChangePriceModel}
              onHide={handleCloseChangePrice}
              size="lg"
              centered
            >
              <Modal.Header>
                <Modal.Title>Change Reserve Price</Modal.Title>
                <i
                  className="fa fa-times CloseModal"
                  onClick={handleCloseChangePrice}
                ></i>
              </Modal.Header>
              <Modal.Body>
                <Form>
                  <Form.Group controlId="formLotNo">
                    <Form.Label>Lot No.</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={lotNos.length}
                      value={lotNos.join("\n")}
                      readOnly
                    />
                  </Form.Group>

                  <Form.Group>
                    <Form.Check
                      type="radio"
                      id="RsChangeRP"
                      name="priceChange"
                      value="RsChangeRP"
                      label="Rs. Change in RP"
                      checked={selectedRadio === "RsChangeRP"}
                      onChange={handleRadioChange}
                    />
                    {selectedRadio === "RsChangeRP" && (
                      <Form.Control
                        type="text"
                        placeholder="Enter new RP"
                        value={textBoxValue}
                        onChange={handleTextBoxChange}
                      />
                    )}
                  </Form.Group>

                  <Form.Group>
                    <Form.Check
                      type="radio"
                      id="MakeRPHBP"
                      name="priceChange"
                      value="MakeRPHBP"
                      label="Make RP = HBP"
                      checked={selectedRadio === "MakeRPHBP"}
                      onChange={handleRadioChange}
                    />
                  </Form.Group>

                  <div className="BtnGroup">
                    <Button className="SubmitBtn" onClick={handleSubmit}>
                      Submit
                    </Button>
                  </div>
                </Form>
              </Modal.Body>
            </Modal>
          )}
        </div>
      )}

      {showListMsg && (
        <Modal show={showListMsg} onHide={handleCloseMsg} size="lg" centered>
          <Modal.Header>
            <i className="fa fa-times CloseModal" onClick={handleCloseMsg}></i>
          </Modal.Header>
          <Modal.Body>
            {alertMessage &&
              alertMessage.map((msg, index) => <p key={index}>{msg.msg}</p>)}
          </Modal.Body>
        </Modal>
      )}

      {showColumn && (
        <Modal show={showColumn} onHide={handleCloseColumn}>
          <Modal.Header>
            <Modal.Title>Table Setting</Modal.Title>
            <i
              className="fa fa-times CloseModal"
              onClick={handleCloseColumn}
            ></i>
          </Modal.Header>

          <Modal.Body>
            <div className="row">
              <div class="col-md-12">
                <div class="CardBox">
                  <h5 class="SmallTitle">Select Column</h5>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="selectAll"
                      checked={isChecked}
                      onChange={(event) => {
                        SelectAllCatalog(event);
                      }}
                    />
                    <label className="ml-2" htmlFor="selectAll">
                      <b>Select/Deselect All</b>
                    </label>
                  </div>
                  <ul>
                    {CatalogConfigColumnDetails &&
                      CatalogConfigColumnDetails.map((data, index) => (
                        <li>
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="isShown"
                              value={data.isShown}
                              id={data.columnTypeId}
                              checked={data.isShown == 1 ? true : false}
                              onChange={(event) => {
                                selectRecordCatalog(
                                  event.target.name,
                                  event.target.checked == true ? 1 : 0,
                                  data.columnTypeId
                                );
                              }}
                              disabled={data.isEditable == 0 ? true : false}
                            />
                            <label className="ml-2">{data.columnName}</label>
                          </div>
                        </li>
                      ))}
                  </ul>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="SubmitBtn"
              onClick={() => handleCatalogStickySubmit()}
            >
              Apply
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {showValuation && (
        <Modal
          show={showValuation}
          onHide={handleCloseValuation}
          size="lg"
          centered
        >
          <Modal.Header>
            <Modal.Title>Valuation</Modal.Title>
            <i
              className="fa fa-times CloseModal"
              onClick={handleCloseValuation}
            ></i>
          </Modal.Header>
          <Modal.Body>
            <div style={{ padding: "20px", borderRadius: "5px" }}>
              <form onSubmit={handleSubmitValue}>
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-md-4">
                      <label className="form-label">
                        Sr No.
                        <input
                          className="form-control"
                          type="text"
                          name="srNo"
                          value={lotNos}
                          readOnly
                        />
                      </label>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">
                        Mark
                        <input
                          className="form-control"
                          type="text"
                          name="mark"
                          value={Mark}
                          readOnly
                        />
                      </label>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">
                        Grade
                        <input
                          className="form-control"
                          type="text"
                          name="grade"
                          value={grade}
                          readOnly
                        />
                      </label>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="row">
                        <div className="col-md-12">
                          <label className="form-label">My Valuation </label>
                          <input
                            className="form-control w-100"
                            type="text"
                            name="valuation"
                            value={formData.myValuation}
                            onChange={handleChangeGroupCode}
                          />
                          {validationErrors.valuation && (
                            <span className="text-danger">
                              {validationErrors.valuation}
                            </span>
                          )}
                        </div>

                        <div className="col-md-12">
                          <label className="form-label">My Comments </label>
                          <textarea
                            className="form-control w-100 textareaEng"
                            name="comments"
                            value={formData.myComments}
                            onChange={handleChangeGroupCode}
                          />
                          {validationErrors.comments && (
                            <span className="text-danger">
                              {validationErrors.comments}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div>
                        <label className="form-label">Group Code</label>
                        <select
                          className="form-control w-100"
                          name="groupCode"
                          value={formData.groupCode}
                          onChange={handleChangeGroupCode}
                        >
                          {GroupCodedata?.map((group, index) => (
                            <option key={index} value={group[0]}>
                              {group[0]}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-12">
                      <Button className="SubmitBtn" type="submit">
                        Submit
                      </Button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};
export default EnglishAuction;
